(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ccf-custom-builder"] && !Shopify.designMode) return;
  try {
    
(function() {
  "use strict";

  var STORAGE_PREFIX = "ccf-custom-builder-v4:";
  var PREVIEW_DELAY_MS = 450;
  var PREVIEW_INK = "#278fba";
  var PREVIEW_INK_RGB = [39, 143, 186];
  var SAVE_LIMIT = 5;
  var SAVE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  var ALLOWED_PUNCTUATION = " &'\u2019.,!?-\u2013\u2014+/():;#_@$%";

  function ccfNormalizeOption(value) {
    return String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
  }

  function ccfProductTypeOption(productType) {
    return productType === "stamp_cutter" ? "Stamp + Cutter" : "Stamp Only";
  }

  function ccfFindExactAvailableVariant(product, shapeLabel, sizeName, productType) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var expectedShape = ccfNormalizeOption(shapeLabel);
    var expectedSize = ccfNormalizeOption(sizeName);
    var expectedType = ccfNormalizeOption(ccfProductTypeOption(productType));
    return variants.find(function(variant) {
      return variant && variant.available === true &&
        ccfNormalizeOption(variant.option1) === expectedShape &&
        ccfNormalizeOption(variant.option2) === expectedSize &&
        ccfNormalizeOption(variant.option3) === expectedType;
    }) || null;
  }

  function ccfMakeId(prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return prefix + "-" + window.crypto.randomUUID();
    }
    return prefix + "-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
  }

  function ccfAllowedCharacter(character) {
    if (ALLOWED_PUNCTUATION.indexOf(character) !== -1) return true;
    try {
      return /[\p{L}\p{M}\p{N}]/u.test(character);
    } catch (_error) {
      return /^[A-Za-z0-9]$/.test(character);
    }
  }

  function ccfSanitizeDesignText(value) {
    var kept = [];
    var removed = [];
    Array.from(String(value || "")).forEach(function(character) {
      if (ccfAllowedCharacter(character)) kept.push(character);
      else removed.push(character);
    });
    return { value: kept.join(""), removed: removed };
  }

  function ccfSetPanelExpanded(button, panel, expanded) {
    button.setAttribute("aria-expanded", expanded ? "true" : "false");
    panel.hidden = !expanded;
  }

  function ccfMoney(cents) {
    var value = Number(cents);
    if (!Number.isFinite(value)) return "-";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-AU", {
        style: "currency",
        currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "AUD"
      }).format(value / 100);
    } catch (_error) {
      return "$" + (value / 100).toFixed(2);
    }
  }

  function ccfRequestJson(url, options) {
    return fetch(url, options).then(function(response) {
      return response.json().catch(function() { return {}; }).then(function(payload) {
        if (!response.ok || payload.ok === false) {
          var error = new Error(payload.error || "The custom builder is temporarily unavailable.");
          error.status = response.status;
          error.issues = Array.isArray(payload.issues) ? payload.issues : [];
          throw error;
        }
        return payload;
      });
    });
  }

  function ccfBuilder(root) {
    if (!root || root.dataset.ccfReady === "true") return;
    root.dataset.ccfReady = "true";

    var configNode = root.querySelector("[data-ccf-config]");
    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (_error) {
      root.innerHTML = '<div class="ccf-notice ccf-notice--error" role="alert">The designer configuration could not be loaded.</div>';
      return;
    }

    var catalog = config.catalog || {};
    var settings = config.settings || {};
    var shapes = Array.isArray(catalog.shapes) ? catalog.shapes : [];
    var fonts = Array.isArray(catalog.fonts) ? catalog.fonts : [];
    var elementTypes = Array.isArray(catalog.elements) ? catalog.elements : [];
    var productTypes = Array.isArray(catalog.productTypes) ? catalog.productTypes : [];
    var limits = catalog.limits || {};
    if (!shapes.length || !fonts.length || !productTypes.length) {
      root.innerHTML = '<div class="ccf-notice ccf-notice--error" role="alert">The designer catalog is incomplete.</div>';
      return;
    }

    function one(selector) { return root.querySelector(selector); }
    function all(selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
    function button(label, className) {
      var node = document.createElement("button");
      node.type = "button";
      node.textContent = label;
      if (className) node.className = className;
      return node;
    }

    var nodes = {
      shapes: one("[data-shapes]"),
      sizes: one("[data-sizes]"),
      productTypes: one("[data-product-types]"),
      variantStatus: one("[data-variant-status]"),
      price: one("[data-price]"),
      stages: all("[data-stage]"),
      progress: all("[data-progress]"),
      back: one("[data-back]"),
      next: one("[data-next]"),
      save: one("[data-save]"),
      resume: one("[data-resume]"),
      savedDesigns: one("[data-saved-designs]"),
      startNew: one("[data-start-new]"),
      globalError: one("[data-global-error]"),
      layerTabs: one("[data-layer-tabs]"),
      textInput: one("[data-text-input]"),
      proofTextInput: one("[data-proof-text-input]"),
      textHelp: one("[data-text-help]"),
      addLayer: one("[data-add-layer]"),
      removeLayer: one("[data-remove-layer]"),
      fonts: one("[data-fonts]"),
      height: one("[data-height]"),
      heightOutput: one("[data-height-output]"),
      curve: one("[data-curve]"),
      curveOutput: one("[data-curve-output]"),
      rotation: one("[data-rotation]"),
      rotationOutput: one("[data-rotation-output]"),
      elements: one("[data-elements]"),
      selectedElements: one("[data-selected-elements]"),
      proofDock: one("[data-proof-dock]"),
      previewTabs: all("[data-preview-tab]"),
      previewPanels: all("[data-preview-panel]"),
      proofHome: one("[data-proof-home]"),
      mobileProofSlot: one("[data-mobile-proof-slot]"),
      reviewProofSlot: one("[data-review-proof-slot]"),
      proofFrame: one("[data-proof-frame]"),
      editorCanvas: one("[data-editor-canvas]"),
      editorSelection: one("[data-editor-selection]"),
      editorToolbar: one("[data-editor-toolbar]"),
      proofPlaceholder: one("[data-proof-placeholder]"),
      proofBadge: one("[data-proof-badge]"),
      proofMessage: one("[data-proof-message]"),
      designClash: one("[data-design-clash]"),
      designClashMessage: one("[data-design-clash-message]"),
      designAutoFix: one("[data-design-auto-fix]"),
      designClashStatus: one("[data-design-clash-status]"),
      threeFrame: one("[data-three-frame]"),
      threeCanvas: one("[data-three-canvas]"),
      threeSpec: one("[data-three-spec]"),
      threeBadge: one("[data-three-badge]"),
      threeHelp: one("[data-three-help]"),
      threeModes: all("[data-three-mode]"),
      threeMirror: one("[data-three-mirror]"),
      threeViews: all("[data-three-view]"),
      review: one("[data-review]"),
      dialogReview: one("[data-dialog-review]"),
      reviewPrice: one("[data-review-price]"),
      approval: one("[data-approval]"),
      openCartReview: one("[data-open-cart-review]"),
      cartReviewDialog: one("[data-cart-review-dialog]"),
      closeCartReview: all("[data-close-cart-review]"),
      cartReviewCanvas: one("[data-cart-review-canvas]"),
      addCart: one("[data-add-cart]"),
      cartStatus: one("[data-cart-status]"),
      openHelp: one("[data-open-help]"),
      helpDialog: one("[data-help-dialog]"),
      helpForm: one("[data-help-form]"),
      closeHelp: all("[data-close-help]"),
      helpName: one("[data-help-name]"),
      helpEmail: one("[data-help-email]"),
      helpNote: one("[data-help-note]"),
      helpWebsite: one("[data-help-website]"),
      helpConsent: one("[data-help-consent]"),
      submitHelp: one("[data-submit-help]"),
      helpStatus: one("[data-help-status]"),
      helpResponse: one("[data-help-response]"),
      helpResponseMessage: one("[data-help-response-message]")
    };

    var firstShape = shapes[0];
    var firstFont = fonts[0];
    function freshDesignState() {
      return {
        schemaVersion: catalog.schemaVersion,
        catalogVersion: catalog.catalogVersion,
        rendererVersion: catalog.rendererVersion,
        designId: ccfMakeId("design"),
        revision: 1,
        shapeId: firstShape.id,
        sizeName: firstShape.sizes[0].name,
        product: productTypes[0].id,
        textLayers: [{
          id: ccfMakeId("text"),
          text: "",
          fontId: firstFont.id,
          heightMm: Number(firstFont.minHeightMm),
          x: 0.5,
          y: 0.5,
          curve: 0,
          rotation: 0
        }],
        elements: [],
        selected: null,
        guides: true
      };
    }

    var state = freshDesignState();

    var step = 1;
    var activeLayerId = state.textLayers[0].id;
    var product = null;
    var variant = null;
    var productPromise = null;
    var previewTimer = 0;
    var previewController = null;
    var previewSequence = 0;
    var lastPreview = null;
    var exactProofCanvas = null;
    var exactProofChecksum = "";
    var exactProofRenderHash = "";
    var committedChecksum = "";
    var helpRequestId = "";
    var helpSubmitting = false;
    var composing = false;
    var storageKey = STORAGE_PREFIX + (settings.productHandle || "builder");
    var savedListKey = STORAGE_PREFIX + "saved-designs:" + (settings.productHandle || "builder");
    var editorContext = nodes.editorCanvas && nodes.editorCanvas.getContext("2d");
    var editorHits = [];
    var activePointers = new Map();
    var dragState = null;
    var pinchState = null;
    var previewMode = "2d";
    var threeContext = nodes.threeCanvas && nodes.threeCanvas.getContext("2d");
    var threeView = { yaw: -0.52, pitch: 0.72, zoom: 1 };
    var threePreviewKind = "impression";
    var threePreviewFlipped = false;
    var threePointers = new Map();
    var threeLastPinchDistance = 0;
    var threeFrameRequest = 0;

    function currentShape() {
      return shapes.find(function(item) { return item.id === state.shapeId; }) || shapes[0];
    }

    function currentSize() {
      var shape = currentShape();
      return shape.sizes.find(function(item) { return ccfNormalizeOption(item.name) === ccfNormalizeOption(state.sizeName); }) || shape.sizes[0];
    }

    function currentLayer() {
      return state.textLayers.find(function(item) { return item.id === activeLayerId; }) || state.textLayers[0];
    }

    function currentFont() {
      var layer = currentLayer();
      return fonts.find(function(item) { return item.id === layer.fontId; }) || fonts[0];
    }

    function fontForLayer(layer) {
      return fonts.find(function(item) { return item.id === layer.fontId; }) || fonts[0];
    }

    function elementSpec(element) {
      return elementTypes.find(function(item) { return item.id === element.type; }) || {
        id: element.type,
        label: String(element.type || "Element").replace(/_/g, " ").replace(/\b\w/g, function(character) { return character.toUpperCase(); }),
        minSizeMm: 8,
        supportsOutline: false
      };
    }

    function selectedObject() {
      if (!state.selected) return null;
      if (state.selected.kind === "text") {
        return state.textLayers.find(function(item) { return item.id === state.selected.id; }) || null;
      }
      return state.elements.find(function(item) { return item.id === state.selected.id; }) || null;
    }

    function selectEditorObject(kind, id) {
      state.selected = { kind: kind, id: id };
      if (kind === "text") {
        activeLayerId = id;
        renderLayerEditor();
      }
      renderEditor();
    }

    function normalizedSvgPath(commands, centerX, centerY, width, height) {
      return commands.map(function(command) {
        var operation = command[0];
        var values = command.slice(1).map(Number);
        function x(index) { return (centerX + values[index] * width).toFixed(2); }
        function y(index) { return (centerY + values[index] * height).toFixed(2); }
        if (operation === "M" || operation === "L") return operation + x(0) + " " + y(1);
        if (operation === "C") return operation + x(0) + " " + y(1) + " " + x(2) + " " + y(3) + " " + x(4) + " " + y(5);
        return operation === "Z" ? "Z" : "";
      }).join(" ");
    }

    function renderShapeIcon(shapeId) {
      var namespace = "http://www.w3.org/2000/svg";
      var svg = document.createElementNS(namespace, "svg");
      svg.setAttribute("class", "ccf-shape-icon");
      svg.setAttribute("viewBox", "0 0 100 76");
      svg.setAttribute("aria-hidden", "true");
      var node;
      if (shapeId === "circle") {
        node = document.createElementNS(namespace, "ellipse");
        node.setAttribute("cx", "50"); node.setAttribute("cy", "38"); node.setAttribute("rx", "28"); node.setAttribute("ry", "28");
      } else if (shapeId === "square") {
        node = document.createElementNS(namespace, "rect");
        node.setAttribute("x", "22"); node.setAttribute("y", "10"); node.setAttribute("width", "56"); node.setAttribute("height", "56"); node.setAttribute("rx", "7");
      } else if (shapeId === "rectangle") {
        node = document.createElementNS(namespace, "rect");
        node.setAttribute("x", "12"); node.setAttribute("y", "20"); node.setAttribute("width", "76"); node.setAttribute("height", "38"); node.setAttribute("rx", "7");
      } else if (shapeId === "heart") {
        node = document.createElementNS(namespace, "path");
        node.setAttribute("d", "M50 66 C44 56 16 42 16 24 C16 8 37 5 50 21 C63 5 84 8 84 24 C84 42 56 56 50 66 Z");
      } else if (shapeId === "arch") {
        node = document.createElementNS(namespace, "path");
        node.setAttribute("d", "M24 66 V35 C24 17 35 8 50 8 C65 8 76 17 76 35 V66 Z");
      } else if (shapeId === "oval") {
        node = document.createElementNS(namespace, "ellipse");
        node.setAttribute("cx", "50"); node.setAttribute("cy", "38"); node.setAttribute("rx", "36"); node.setAttribute("ry", "24");
      } else {
        node = document.createElementNS(namespace, "path");
        var shapeSpec = shapes.find(function(shape) { return shape.id === shapeId; });
        var outline = shapeSpec && Array.isArray(shapeSpec.path) ? shapeSpec.path : [];
        node.setAttribute("d", normalizedSvgPath(outline, 50, 38, 58, 58));
      }
      svg.appendChild(node);
      return svg;
    }

    function roundedRectPath(context, x, y, width, height, radius) {
      var r = Math.min(radius, width / 2, height / 2);
      context.moveTo(x + r, y);
      context.lineTo(x + width - r, y);
      context.quadraticCurveTo(x + width, y, x + width, y + r);
      context.lineTo(x + width, y + height - r);
      context.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
      context.lineTo(x + r, y + height);
      context.quadraticCurveTo(x, y + height, x, y + height - r);
      context.lineTo(x, y + r);
      context.quadraticCurveTo(x, y, x + r, y);
    }

    function normalizedShapePath(context, commands, centerX, centerY, width, height) {
      commands.forEach(function(command) {
        var operation = command[0];
        if (operation === "M") context.moveTo(centerX + Number(command[1]) * width, centerY + Number(command[2]) * height);
        else if (operation === "L") context.lineTo(centerX + Number(command[1]) * width, centerY + Number(command[2]) * height);
        else if (operation === "C") {
          context.bezierCurveTo(
            centerX + Number(command[1]) * width,
            centerY + Number(command[2]) * height,
            centerX + Number(command[3]) * width,
            centerY + Number(command[4]) * height,
            centerX + Number(command[5]) * width,
            centerY + Number(command[6]) * height
          );
        } else if (operation === "Z") context.closePath();
      });
    }

    function shapePath(context, shapeId, width, height, inset) {
      var x = inset;
      var y = inset;
      var w = width - inset * 2;
      var h = height - inset * 2;
      context.beginPath();
      if (shapeId === "circle" || shapeId === "oval") {
        context.ellipse(width / 2, height / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
      } else if (shapeId === "square" || shapeId === "rectangle") {
        roundedRectPath(context, x, y, w, h, Math.min(w, h) * 0.08);
      } else if (shapeId === "heart") {
        context.moveTo(width / 2, y + h);
        context.bezierCurveTo(x + w * 0.42, y + h * 0.82, x, y + h * 0.55, x, y + h * 0.28);
        context.bezierCurveTo(x, y - h * 0.02, x + w * 0.36, y - h * 0.08, width / 2, y + h * 0.22);
        context.bezierCurveTo(x + w * 0.64, y - h * 0.08, x + w, y - h * 0.02, x + w, y + h * 0.28);
        context.bezierCurveTo(x + w, y + h * 0.55, x + w * 0.58, y + h * 0.82, width / 2, y + h);
      } else if (shapeId === "arch") {
        context.moveTo(x, y + h);
        context.lineTo(x, y + h * 0.42);
        context.bezierCurveTo(x, y + h * 0.12, x + w * 0.22, y, width / 2, y);
        context.bezierCurveTo(x + w * 0.78, y, x + w, y + h * 0.12, x + w, y + h * 0.42);
        context.lineTo(x + w, y + h);
        context.closePath();
      } else if (shapeId === "curvyframe") {
        var curvyShape = shapes.find(function(shape) { return shape.id === "curvyframe"; });
        var curvyCommands = curvyShape && Array.isArray(curvyShape.path) ? curvyShape.path : [];
        normalizedShapePath(context, curvyCommands, width / 2, height / 2, w, h);
      }
      context.closePath();
    }

    function ccfCubicPoint(start, controlA, controlB, end, amount) {
      var inverse = 1 - amount;
      return {
        x: inverse * inverse * inverse * start.x + 3 * inverse * inverse * amount * controlA.x + 3 * inverse * amount * amount * controlB.x + amount * amount * amount * end.x,
        y: inverse * inverse * inverse * start.y + 3 * inverse * inverse * amount * controlA.y + 3 * inverse * amount * amount * controlB.y + amount * amount * amount * end.y
      };
    }

    function ccfAppendCubic(points, start, controlA, controlB, end, segments) {
      for (var cubicIndex = 1; cubicIndex <= segments; cubicIndex += 1) {
        points.push(ccfCubicPoint(start, controlA, controlB, end, cubicIndex / segments));
      }
    }

    function ccfShapeOutlinePoints(shapeId, widthMm, heightMm) {
      var points = [];
      var halfWidth = widthMm / 2;
      var halfHeight = heightMm / 2;
      var index;
      if (shapeId === "circle" || shapeId === "oval") {
        for (index = 0; index < 120; index += 1) {
          var angle = -Math.PI / 2 + index / 120 * Math.PI * 2;
          points.push({ x: Math.cos(angle) * halfWidth, y: Math.sin(angle) * halfHeight });
        }
        return points;
      }
      if (shapeId === "square" || shapeId === "rectangle") {
        var radius = Math.min(widthMm, heightMm) * 0.08;
        var corners = [
          { x: halfWidth - radius, y: -halfHeight + radius, start: -Math.PI / 2 },
          { x: halfWidth - radius, y: halfHeight - radius, start: 0 },
          { x: -halfWidth + radius, y: halfHeight - radius, start: Math.PI / 2 },
          { x: -halfWidth + radius, y: -halfHeight + radius, start: Math.PI }
        ];
        corners.forEach(function(corner) {
          for (var cornerIndex = 0; cornerIndex <= 12; cornerIndex += 1) {
            var cornerAngle = corner.start + cornerIndex / 12 * Math.PI / 2;
            points.push({ x: corner.x + Math.cos(cornerAngle) * radius, y: corner.y + Math.sin(cornerAngle) * radius });
          }
        });
        return points;
      }
      if (shapeId === "heart") {
        var heartStart = { x: 0, y: halfHeight };
        points.push(heartStart);
        var heartA = { x: -widthMm * 0.08, y: heightMm * 0.32 };
        ccfAppendCubic(points, heartStart, heartA, { x: -halfWidth, y: heightMm * 0.05 }, { x: -halfWidth, y: -heightMm * 0.22 }, 24);
        var heartB = points[points.length - 1];
        ccfAppendCubic(points, heartB, { x: -halfWidth, y: -heightMm * 0.52 }, { x: -widthMm * 0.14, y: -heightMm * 0.58 }, { x: 0, y: -heightMm * 0.28 }, 24);
        var heartC = points[points.length - 1];
        ccfAppendCubic(points, heartC, { x: widthMm * 0.14, y: -heightMm * 0.58 }, { x: halfWidth, y: -heightMm * 0.52 }, { x: halfWidth, y: -heightMm * 0.22 }, 24);
        var heartD = points[points.length - 1];
        ccfAppendCubic(points, heartD, { x: halfWidth, y: heightMm * 0.05 }, { x: widthMm * 0.08, y: heightMm * 0.32 }, heartStart, 24);
        return points;
      }
      if (shapeId === "arch") {
        points.push({ x: -halfWidth, y: halfHeight }, { x: -halfWidth, y: -heightMm * 0.08 });
        var archLeft = points[points.length - 1];
        ccfAppendCubic(points, archLeft, { x: -halfWidth, y: -heightMm * 0.38 }, { x: -widthMm * 0.28, y: -halfHeight }, { x: 0, y: -halfHeight }, 24);
        var archTop = points[points.length - 1];
        ccfAppendCubic(points, archTop, { x: widthMm * 0.28, y: -halfHeight }, { x: halfWidth, y: -heightMm * 0.38 }, { x: halfWidth, y: -heightMm * 0.08 }, 24);
        points.push({ x: halfWidth, y: halfHeight });
        return points;
      }
      if (shapeId === "curvyframe") {
        var curvyShape = shapes.find(function(shape) { return shape.id === "curvyframe"; });
        var commands = curvyShape && Array.isArray(curvyShape.path) ? curvyShape.path : [];
        var cursor = { x: 0, y: 0 };
        commands.forEach(function(command) {
          var operation = command[0];
          if (operation === "M" || operation === "L") {
            cursor = { x: Number(command[1]) * widthMm, y: Number(command[2]) * heightMm };
            points.push(cursor);
          } else if (operation === "C") {
            var controlA = { x: Number(command[1]) * widthMm, y: Number(command[2]) * heightMm };
            var controlB = { x: Number(command[3]) * widthMm, y: Number(command[4]) * heightMm };
            var end = { x: Number(command[5]) * widthMm, y: Number(command[6]) * heightMm };
            ccfAppendCubic(points, cursor, controlA, controlB, end, 18);
            cursor = end;
          }
        });
        if (points.length > 2) return points;
      }
      return ccfShapeOutlinePoints("circle", widthMm, heightMm);
    }

    function drawElementGraphic(context, type, size, mode, strokeWidth) {
      var radius = size * 0.45;
      var outline = mode === "outline";
      context.beginPath();
      if (type === "star") {
        for (var starIndex = 0; starIndex < 10; starIndex += 1) {
          var starAngle = -Math.PI / 2 + starIndex * Math.PI / 5;
          var starRadius = starIndex % 2 === 0 ? radius : radius * 0.44;
          var starX = Math.cos(starAngle) * starRadius;
          var starY = Math.sin(starAngle) * starRadius;
          if (starIndex === 0) context.moveTo(starX, starY); else context.lineTo(starX, starY);
        }
        context.closePath();
      } else if (type === "heart") {
        context.moveTo(0, radius);
        context.bezierCurveTo(-radius * 0.2, radius * 0.66, -radius, radius * 0.2, -radius, -radius * 0.32);
        context.bezierCurveTo(-radius, -radius, -radius * 0.2, -radius, 0, -radius * 0.42);
        context.bezierCurveTo(radius * 0.2, -radius, radius, -radius, radius, -radius * 0.32);
        context.bezierCurveTo(radius, radius * 0.2, radius * 0.2, radius * 0.66, 0, radius);
        context.closePath();
      } else if (type === "cross") {
        var crossStem = radius * 0.18;
        var crossBarY = -radius * 0.34;
        context.rect(-crossStem, -radius, crossStem * 2, radius * 2);
        context.rect(-radius * 0.7, crossBarY - crossStem, radius * 1.4, crossStem * 2);
      } else if (type === "sparkle") {
        context.moveTo(0, -radius); context.lineTo(radius * 0.22, -radius * 0.22); context.lineTo(radius, 0); context.lineTo(radius * 0.22, radius * 0.22); context.lineTo(0, radius); context.lineTo(-radius * 0.22, radius * 0.22); context.lineTo(-radius, 0); context.lineTo(-radius * 0.22, -radius * 0.22); context.closePath();
      } else if (type === "daisy" || type === "flower") {
        for (var petalIndex = 0; petalIndex < 8; petalIndex += 1) {
          context.save(); context.rotate(petalIndex * Math.PI / 4); context.ellipse(0, -radius * 0.58, radius * 0.22, radius * 0.48, 0, 0, Math.PI * 2); context.restore();
        }
        context.arc(0, 0, radius * 0.27, 0, Math.PI * 2);
      } else if (type === "crown") {
        context.moveTo(-radius * 0.94, radius * 0.60);
        context.lineTo(-radius * 0.82, -radius * 0.62);
        context.lineTo(-radius * 0.30, -radius * 0.08);
        context.lineTo(0, -radius * 0.90);
        context.lineTo(radius * 0.30, -radius * 0.08);
        context.lineTo(radius * 0.82, -radius * 0.62);
        context.lineTo(radius * 0.94, radius * 0.60);
        context.closePath();
        context.rect(-radius * 0.96, radius * 0.43, radius * 1.92, radius * 0.31);
      } else if (type === "gift_box") {
        var giftLine = Math.max(2, strokeWidth || size * 0.125);
        context.lineJoin = "round";
        context.lineCap = "round";
        context.lineWidth = giftLine;
        context.strokeRect(-radius * 0.80, -radius * 0.18, radius * 1.60, radius);
        context.beginPath();
        context.moveTo(0, -radius * 0.20);
        context.lineTo(0, radius * 0.82);
        context.moveTo(-radius * 0.80, radius * 0.12);
        context.lineTo(radius * 0.80, radius * 0.12);
        context.stroke();
        context.beginPath();
        context.ellipse(-radius * 0.40, -radius * 0.48, radius * 0.36, radius * 0.32, 0, 0, Math.PI * 2);
        context.ellipse(radius * 0.40, -radius * 0.48, radius * 0.36, radius * 0.32, 0, 0, Math.PI * 2);
        context.stroke();
        context.beginPath();
        context.arc(0, -radius * 0.18, radius * 0.22, 0, Math.PI * 2);
        context.fill();
        return;
      } else if (type === "botanical_sprig" || type === "leaf") {
        context.lineJoin = "round";
        context.lineCap = "round";
        context.lineWidth = Math.max(2, strokeWidth || size * 0.11);
        context.moveTo(-radius * 0.74, radius * 0.74);
        context.lineTo(radius * 0.74, -radius * 0.74);
        context.stroke();
        [[-0.46, -1], [-0.18, 1], [0.1, -1], [0.38, 1]].forEach(function(pair) {
          var leafX = pair[0] * radius + pair[1] * radius * 0.18;
          var leafY = -pair[0] * radius + pair[1] * radius * 0.18;
          context.beginPath();
          context.ellipse(leafX, leafY, radius * 0.17, radius * 0.34, -Math.PI / 4 + pair[1] * 0.62, 0, Math.PI * 2);
          context.fill();
        });
        context.beginPath();
        context.ellipse(radius * 0.69, -radius * 0.69, radius * 0.15, radius * 0.3, Math.PI / 4, 0, Math.PI * 2);
        context.fill();
        return;
      } else if (type === "bow") {
        context.lineJoin = "round";
        context.lineCap = "round";
        context.lineWidth = Math.max(2, radius * 0.28);
        context.ellipse(-radius * 0.5, -radius * 0.14, radius * 0.45, radius * 0.32, -0.16, 0, Math.PI * 2);
        context.ellipse(radius * 0.5, -radius * 0.14, radius * 0.45, radius * 0.32, 0.16, 0, Math.PI * 2);
        context.stroke();
        context.beginPath();
        [[[-0.12, 0.1], [-0.7, 0.92], [-0.47, 0.72], [-0.22, 0.9], [0, 0.28]], [[0.12, 0.1], [0.7, 0.92], [0.47, 0.72], [0.22, 0.9], [0, 0.28]]].forEach(function(points) {
          points.forEach(function(point, index) {
            if (index === 0) context.moveTo(point[0] * radius, point[1] * radius);
            else context.lineTo(point[0] * radius, point[1] * radius);
          });
          context.closePath();
        });
        context.moveTo(radius * 0.28, 0);
        context.arc(0, 0, radius * 0.28, 0, Math.PI * 2);
        context.fill();
        return;
      } else if (type === "ampersand_loop") {
        context.moveTo(0, 0);
        for (var loopIndex = 0; loopIndex <= 80; loopIndex += 1) {
          var loopT = loopIndex / 80 * Math.PI * 2;
          context.lineTo(Math.sin(loopT) * radius * 0.82, Math.sin(loopT * 2) * radius * 0.54);
        }
      } else {
        context.arc(0, 0, radius, Math.PI, 0);
        context.moveTo(-radius, 0); context.lineTo(-radius, radius * 0.36);
        context.moveTo(radius, 0); context.lineTo(radius, radius * 0.36);
      }
      context.lineJoin = "round";
      context.lineCap = "round";
      context.lineWidth = Math.max(2, strokeWidth || size * 0.09);
      if (outline || type === "ampersand_loop" || type === "rainbow") context.stroke();
      else context.fill();
    }

    function renderElementThumbnail(canvas, type) {
      var context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.save();
      context.translate(canvas.width / 2, canvas.height / 2);
      context.fillStyle = "#10658f";
      context.strokeStyle = "#10658f";
      drawElementGraphic(context, type, Math.min(canvas.width, canvas.height) * 0.78, "filled", 4);
      context.restore();
    }

    function showDesignPreview() {
      nodes.editorCanvas.hidden = false;
      nodes.editorSelection.hidden = false;
      nodes.editorToolbar.hidden = !state.selected;
      nodes.proofPlaceholder.hidden = true;
    }

    function updateEditorSelection() {
      var selected = selectedObject();
      if (!selected || !state.selected) {
        nodes.editorSelection.textContent = "Tap text or an element in the preview to select it.";
        nodes.editorToolbar.hidden = true;
        return;
      }
      if (state.selected.kind === "text") {
        var index = state.textLayers.indexOf(selected);
        nodes.editorSelection.textContent = "Text line " + (index + 1) + " selected. Drag to position or pinch to resize.";
      } else {
        var spec = elementSpec(selected);
        nodes.editorSelection.textContent = (spec ? spec.label : "Element") + " selected. Drag to position or pinch to resize.";
      }
      nodes.editorToolbar.hidden = !state.selected;
    }

    function drawEditorText(context, layer, width, height) {
      var size = currentSize();
      var spec = fontForLayer(layer);
      var fontPx = Math.max(12, Number(layer.heightMm) / Number(size.heightMm) * height * 1.18);
      var x = Number(layer.x) * width;
      var y = Number(layer.y) * height;
      var text = String(layer.text || "");
      context.save();
      context.translate(x, y);
      context.rotate(Number(layer.rotation || 0) * Math.PI / 180);
      context.fillStyle = PREVIEW_INK;
      context.font = String(spec.instantPreviewStyle || "normal") + " " + Number(spec.instantPreviewWeight || 700) + " " + fontPx + "px " + String(spec.instantPreviewFamily || "Figtree, sans-serif");
      context.textAlign = "center";
      context.textBaseline = "middle";
      var measured = Math.max(fontPx, context.measureText(text || "Text").width);
      var curve = Number(layer.curve || 0);
      if (text && Math.abs(curve) > 0.01) {
        var radius = Math.max(measured * 0.75, Math.min(width, height) * 0.38 / Math.max(0.12, Math.abs(curve)));
        var totalAngle = Math.min(Math.PI * 0.9, measured / radius);
        Array.from(text).forEach(function(character, index, characters) {
          var ratio = characters.length <= 1 ? 0.5 : index / (characters.length - 1);
          var angle = -totalAngle / 2 + totalAngle * ratio;
          context.save();
          context.translate(Math.sin(angle) * radius, (1 - Math.cos(angle)) * radius * (curve > 0 ? -1 : 1));
          context.rotate(angle * (curve > 0 ? 1 : -1));
          context.fillText(character, 0, 0);
          context.restore();
        });
      } else if (text) {
        context.fillText(text, 0, 0);
      } else if (state.selected && state.selected.kind === "text" && state.selected.id === layer.id) {
        context.fillStyle = "rgba(39,143,186,.48)";
        context.fillText("Type here", 0, 0);
      }
      context.restore();
      var hitHeight = fontPx * (1.45 + Math.abs(curve) * 0.8);
      editorHits.push({ kind: "text", id: layer.id, x: x - measured / 2 - 12, y: y - hitHeight / 2 - 12, width: measured + 24, height: hitHeight + 24 });
    }

    function clearExactProof() {
      exactProofCanvas = null;
      exactProofChecksum = "";
      exactProofRenderHash = "";
      if (!nodes.editorCanvas) return;
      nodes.editorCanvas.removeAttribute("data-exact-proof-ready");
      nodes.editorCanvas.removeAttribute("data-exact-proof-render-hash");
      nodes.editorCanvas.removeAttribute("data-exact-proof-fonts");
    }

    function hasExactProof() {
      return !!(
        exactProofCanvas &&
        lastPreview &&
        exactProofChecksum === lastPreview.canonicalChecksum &&
        exactProofRenderHash === lastPreview.renderHash
      );
    }

    function buildExactCustomerProof(proofData) {
      return new Promise(function(resolve, reject) {
        if (!/^data:image\/png;base64,/i.test(String(proofData || ""))) {
          reject(new Error("The exact design preview was not returned."));
          return;
        }
        var image = new Image();
        image.decoding = "async";
        image.onload = function() {
          try {
            var canvas = document.createElement("canvas");
            canvas.width = Math.max(1, image.naturalWidth || image.width);
            canvas.height = Math.max(1, image.naturalHeight || image.height);
            var context = canvas.getContext("2d", { willReadFrequently: true });
            if (!context) throw new Error("The exact design preview could not be prepared.");
            context.drawImage(image, 0, 0);
            var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            var pixels = imageData.data;
            for (var index = 0; index < pixels.length; index += 4) {
              var luminance = Math.round(pixels[index] * 0.2126 + pixels[index + 1] * 0.7152 + pixels[index + 2] * 0.0722);
              var coverage = 255 - luminance;
              pixels[index] = PREVIEW_INK_RGB[0];
              pixels[index + 1] = PREVIEW_INK_RGB[1];
              pixels[index + 2] = PREVIEW_INK_RGB[2];
              pixels[index + 3] = Math.round(pixels[index + 3] * coverage / 255);
            }
            context.putImageData(imageData, 0, 0);
            resolve(canvas);
          } catch (error) {
            reject(error);
          }
        };
        image.onerror = function() { reject(new Error("The exact design preview could not be displayed.")); };
        image.src = proofData;
      });
    }

    function renderEditor() {
      if (!editorContext || !nodes.editorCanvas) return;
      var size = currentSize();
      var logicalWidth = 900;
      var logicalHeight = Math.max(480, Math.round(logicalWidth * Number(size.heightMm) / Number(size.widthMm)));
      if (nodes.editorCanvas.width !== logicalWidth) nodes.editorCanvas.width = logicalWidth;
      if (nodes.editorCanvas.height !== logicalHeight) nodes.editorCanvas.height = logicalHeight;
      nodes.proofFrame.style.aspectRatio = isMobileLayout() ? "auto" : logicalWidth + " / " + logicalHeight;
      editorHits = [];
      editorContext.clearRect(0, 0, logicalWidth, logicalHeight);
      var inset = Math.max(18, Math.min(logicalWidth, logicalHeight) * 0.035);
      var useExactProof = hasExactProof();
      if (useExactProof) {
        editorContext.drawImage(exactProofCanvas, 0, 0, logicalWidth, logicalHeight);
      }
      editorContext.save();
      shapePath(editorContext, currentShape().id, logicalWidth, logicalHeight, inset);
      editorContext.clip();
      if (useExactProof) editorContext.globalAlpha = 0;
      state.elements.forEach(function(element) {
        var x = Number(element.x) * logicalWidth;
        var y = Number(element.y) * logicalHeight;
        var elementSize = Number(element.sizeMm) / Math.min(Number(size.widthMm), Number(size.heightMm)) * Math.min(logicalWidth, logicalHeight);
        editorContext.save();
        editorContext.translate(x, y);
        editorContext.rotate(Number(element.rotation || 0) * Math.PI / 180);
        editorContext.fillStyle = PREVIEW_INK;
        editorContext.strokeStyle = PREVIEW_INK;
        drawElementGraphic(editorContext, element.type, elementSize, element.mode || "filled", Number(element.strokeMm || 1.4) / Math.min(Number(size.widthMm), Number(size.heightMm)) * Math.min(logicalWidth, logicalHeight));
        editorContext.restore();
        editorHits.push({ kind: "element", id: element.id, x: x - elementSize / 2 - 12, y: y - elementSize / 2 - 12, width: elementSize + 24, height: elementSize + 24 });
      });
      state.textLayers.forEach(function(layer) { drawEditorText(editorContext, layer, logicalWidth, logicalHeight); });
      editorContext.restore();
      if (state.guides) {
        editorContext.save();
        editorContext.setLineDash([10, 8]);
        editorContext.lineWidth = 2;
        editorContext.strokeStyle = "rgba(39,143,186,.48)";
        shapePath(editorContext, currentShape().id, logicalWidth, logicalHeight, inset + Math.min(logicalWidth, logicalHeight) * 0.045);
        editorContext.stroke();
        editorContext.setLineDash([6, 7]);
        editorContext.beginPath(); editorContext.moveTo(logicalWidth / 2, inset); editorContext.lineTo(logicalWidth / 2, logicalHeight - inset); editorContext.moveTo(inset, logicalHeight / 2); editorContext.lineTo(logicalWidth - inset, logicalHeight / 2); editorContext.stroke();
        editorContext.restore();
      }
      if (!useExactProof) {
        shapePath(editorContext, currentShape().id, logicalWidth, logicalHeight, inset);
        editorContext.lineWidth = Math.max(5, Math.min(logicalWidth, logicalHeight) * 0.008);
        editorContext.strokeStyle = PREVIEW_INK;
        editorContext.stroke();
      }
      if (state.selected) {
        var selectedHit = editorHits.find(function(hit) { return hit.kind === state.selected.kind && hit.id === state.selected.id; });
        if (selectedHit) {
          editorContext.save();
          editorContext.setLineDash([9, 7]);
          editorContext.lineWidth = 3;
          editorContext.strokeStyle = "#10658f";
          editorContext.strokeRect(selectedHit.x, selectedHit.y, selectedHit.width, selectedHit.height);
          editorContext.restore();
        }
      }
      var guidesButton = nodes.editorToolbar && nodes.editorToolbar.querySelector('[data-editor-action="guides"]');
      if (guidesButton) guidesButton.setAttribute("aria-pressed", state.guides ? "true" : "false");
      nodes.proofPlaceholder.hidden = true;
      updateEditorSelection();
    }

    function ccfThreeProject(point, projection) {
      var cosYaw = Math.cos(threeView.yaw);
      var sinYaw = Math.sin(threeView.yaw);
      var cosPitch = Math.cos(threeView.pitch);
      var sinPitch = Math.sin(threeView.pitch);
      var rotatedX = point.x * cosYaw - point.y * sinYaw;
      var rotatedY = point.x * sinYaw + point.y * cosYaw;
      return {
        x: projection.centerX + rotatedX * projection.scale,
        y: projection.centerY + (rotatedY * cosPitch - point.z * sinPitch) * projection.scale,
        depth: rotatedY * sinPitch + point.z * cosPitch
      };
    }

    function ccfThreeProjection(widthMm, heightMm) {
      var widthAllowance = widthMm + 34;
      var heightAllowance = heightMm + 40;
      var scale = Math.min(
        nodes.threeCanvas.width * 0.88 / widthAllowance,
        nodes.threeCanvas.height * 0.82 / heightAllowance
      ) * threeView.zoom;
      return {
        centerX: nodes.threeCanvas.width * 0.5,
        centerY: nodes.threeCanvas.height * (threeView.pitch < 0.1 ? 0.51 : 0.61),
        scale: scale
      };
    }

    function ccfProjectedPath(context, points, z, projection, reverse) {
      var ordered = reverse ? points.slice().reverse() : points;
      context.beginPath();
      ordered.forEach(function(point, pointIndex) {
        var projected = ccfThreeProject({ x: point.x, y: point.y, z: z }, projection);
        if (pointIndex === 0) context.moveTo(projected.x, projected.y);
        else context.lineTo(projected.x, projected.y);
      });
      context.closePath();
    }

    function ccfDrawThreeShadow(context, points, projection) {
      context.save();
      ccfProjectedPath(context, points, 0, projection, false);
      context.fillStyle = "rgba(9, 48, 70, 0.22)";
      context.shadowColor = "rgba(9, 48, 70, 0.34)";
      context.shadowBlur = 30;
      context.shadowOffsetY = 18;
      context.fill();
      context.restore();
    }

    var CCF_STAMP_MATERIAL = { hue: 198, saturation: 64, side: 39, inner: 31, top: 55, stroke: "rgba(5, 72, 104, 0.28)" };
    var CCF_COOKIE_MATERIAL = { hue: 29, saturation: 54, side: 36, inner: 30, top: 53, stroke: "rgba(91, 43, 23, 0.3)" };

    function ccfScaleThreePoints(points, scaleX, scaleY) {
      return points.map(function(point) { return { x: point.x * scaleX, y: point.y * scaleY }; });
    }

    function ccfDrawThreeBridge(context, lowerPoints, lowerZ, upperPoints, upperZ, projection, innerWall, material) {
      var sides = lowerPoints.map(function(point, pointIndex) {
        var next = lowerPoints[(pointIndex + 1) % lowerPoints.length];
        var upperPoint = upperPoints[pointIndex];
        var upperNext = upperPoints[(pointIndex + 1) % upperPoints.length];
        var lowerA = ccfThreeProject({ x: point.x, y: point.y, z: lowerZ }, projection);
        var lowerB = ccfThreeProject({ x: next.x, y: next.y, z: lowerZ }, projection);
        var upperB = ccfThreeProject({ x: upperNext.x, y: upperNext.y, z: upperZ }, projection);
        var upperA = ccfThreeProject({ x: upperPoint.x, y: upperPoint.y, z: upperZ }, projection);
        var edgeX = next.x - point.x;
        var edgeY = next.y - point.y;
        var edgeLength = Math.max(0.001, Math.sqrt(edgeX * edgeX + edgeY * edgeY));
        var normalX = edgeY / edgeLength;
        var normalY = -edgeX / edgeLength;
        var lightAmount = normalX * -0.48 + normalY * -0.88;
        return { points: [lowerA, lowerB, upperB, upperA], depth: (lowerA.depth + lowerB.depth + upperA.depth + upperB.depth) / 4, lightAmount: lightAmount };
      }).sort(function(a, b) { return a.depth - b.depth; });
      sides.forEach(function(side) {
        var baseTone = innerWall ? material.inner : material.side;
        var tone = Math.max(24, Math.min(58, baseTone + side.lightAmount * (innerWall ? 3.2 : 5.5)));
        context.beginPath();
        side.points.forEach(function(point, pointIndex) {
          if (pointIndex === 0) context.moveTo(point.x, point.y);
          else context.lineTo(point.x, point.y);
        });
        context.closePath();
        context.fillStyle = "hsl(" + material.hue + " " + material.saturation + "% " + tone.toFixed(1) + "%)";
        context.fill();
        context.strokeStyle = material.stroke;
        context.lineWidth = 0.45;
        context.stroke();
      });
    }

    function ccfDrawThreeSides(context, points, lowerZ, upperZ, projection, innerWall, material) {
      ccfDrawThreeBridge(context, points, lowerZ, points, upperZ, projection, innerWall, material);
    }

    function ccfDrawThreeTop(context, points, z, projection, material) {
      var topPoint = ccfThreeProject({ x: 0, y: -currentSize().heightMm / 2, z: z }, projection);
      var bottomPoint = ccfThreeProject({ x: 0, y: currentSize().heightMm / 2, z: z }, projection);
      var gradient = context.createLinearGradient(topPoint.x, topPoint.y, bottomPoint.x, bottomPoint.y);
      gradient.addColorStop(0, "hsl(" + (material.hue - 2) + " " + (material.saturation + 3) + "% " + (material.top + 7) + "%)");
      gradient.addColorStop(0.48, "hsl(" + material.hue + " " + material.saturation + "% " + material.top + "%)");
      gradient.addColorStop(1, "hsl(" + (material.hue + 2) + " " + Math.max(35, material.saturation - 5) + "% " + (material.top - 7) + "%)");
      ccfProjectedPath(context, points, z, projection, false);
      context.fillStyle = gradient;
      context.fill();
      context.strokeStyle = material.stroke;
      context.lineWidth = 1.1;
      context.stroke();
    }

    function ccfDrawCookieTexture(context, points, z, projection, widthMm, heightMm) {
      context.save();
      ccfProjectedPath(context, points, z, projection, false);
      context.clip();
      for (var crumbIndex = 0; crumbIndex < 54; crumbIndex += 1) {
        var crumbX = ((((crumbIndex * 47) % 103) / 102) - 0.5) * widthMm * 0.9;
        var crumbY = ((((crumbIndex * 71 + 17) % 107) / 106) - 0.5) * heightMm * 0.9;
        var crumb = ccfThreeProject({ x: crumbX, y: crumbY, z: z + 0.03 }, projection);
        context.beginPath();
        context.arc(crumb.x, crumb.y, 0.7 + (crumbIndex % 3) * 0.45, 0, Math.PI * 2);
        context.fillStyle = crumbIndex % 4 === 0 ? "rgba(111,55,28,0.15)" : "rgba(255,224,178,0.13)";
        context.fill();
      }
      context.restore();
    }

    function ccfDrawThreeArtworkText(context, layer, width, height) {
      var size = currentSize();
      var spec = fontForLayer(layer);
      var fontPx = Math.max(12, Number(layer.heightMm) / Number(size.heightMm) * height * 1.18);
      var x = Number(layer.x) * width;
      var y = Number(layer.y) * height;
      var text = String(layer.text || "");
      if (!text) return;
      context.save();
      context.translate(x, y);
      context.rotate(Number(layer.rotation || 0) * Math.PI / 180);
      context.font = "700 " + fontPx + "px \"" + spec.family + "\", Figtree, sans-serif";
      context.textAlign = "center";
      context.textBaseline = "middle";
      var measured = Math.max(fontPx, context.measureText(text).width);
      var curve = Number(layer.curve || 0);
      if (Math.abs(curve) > 0.01) {
        var radius = Math.max(measured * 0.75, Math.min(width, height) * 0.38 / Math.max(0.12, Math.abs(curve)));
        var totalAngle = Math.min(Math.PI * 0.9, measured / radius);
        Array.from(text).forEach(function(character, index, characters) {
          var ratio = characters.length <= 1 ? 0.5 : index / (characters.length - 1);
          var angle = -totalAngle / 2 + totalAngle * ratio;
          context.save();
          context.translate(Math.sin(angle) * radius, (1 - Math.cos(angle)) * radius * (curve > 0 ? -1 : 1));
          context.rotate(angle * (curve > 0 ? 1 : -1));
          context.fillText(character, 0, 0);
          context.restore();
        });
      } else {
        context.fillText(text, 0, 0);
      }
      context.restore();
    }

    function ccfBuildThreeArtwork(color, mirrored) {
      var size = currentSize();
      var canvas = document.createElement("canvas");
      canvas.width = 720;
      canvas.height = Math.max(420, Math.round(canvas.width * Number(size.heightMm) / Number(size.widthMm)));
      var context = canvas.getContext("2d");
      if (!context) return canvas;
      var inset = Math.max(20, Math.min(canvas.width, canvas.height) * 0.055);
      context.save();
      if (mirrored) {
        context.translate(canvas.width, 0);
        context.scale(-1, 1);
      }
      if (hasExactProof()) {
        context.drawImage(exactProofCanvas, 0, 0, canvas.width, canvas.height);
        context.globalCompositeOperation = "source-in";
        context.fillStyle = color;
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.globalCompositeOperation = "destination-in";
        var safeInset = Number(limits.safeInsetMm || 3) / Math.min(Number(size.widthMm), Number(size.heightMm)) * Math.min(canvas.width, canvas.height);
        shapePath(context, currentShape().id, canvas.width, canvas.height, safeInset);
        context.fill();
        context.restore();
        return canvas;
      }
      shapePath(context, currentShape().id, canvas.width, canvas.height, inset);
      context.clip();
      context.fillStyle = color;
      context.strokeStyle = color;
      state.elements.forEach(function(element) {
        var elementSize = Number(element.sizeMm) / Math.min(Number(size.widthMm), Number(size.heightMm)) * Math.min(canvas.width, canvas.height);
        context.save();
        context.translate(Number(element.x) * canvas.width, Number(element.y) * canvas.height);
        context.rotate(Number(element.rotation || 0) * Math.PI / 180);
        drawElementGraphic(context, element.type, elementSize, element.mode || "filled", Number(element.strokeMm || 1.4) / Math.min(Number(size.widthMm), Number(size.heightMm)) * Math.min(canvas.width, canvas.height));
        context.restore();
      });
      state.textLayers.forEach(function(layer) { ccfDrawThreeArtworkText(context, layer, canvas.width, canvas.height); });
      context.restore();
      return canvas;
    }

    function ccfDrawProjectedArtwork(context, artwork, z, projection, widthMm, heightMm, offsetX, offsetY) {
      var topLeft = ccfThreeProject({ x: -widthMm / 2, y: -heightMm / 2, z: z }, projection);
      var topRight = ccfThreeProject({ x: widthMm / 2, y: -heightMm / 2, z: z }, projection);
      var bottomLeft = ccfThreeProject({ x: -widthMm / 2, y: heightMm / 2, z: z }, projection);
      context.save();
      context.setTransform(
        (topRight.x - topLeft.x) / artwork.width,
        (topRight.y - topLeft.y) / artwork.width,
        (bottomLeft.x - topLeft.x) / artwork.height,
        (bottomLeft.y - topLeft.y) / artwork.height,
        topLeft.x + Number(offsetX || 0),
        topLeft.y + Number(offsetY || 0)
      );
      context.drawImage(artwork, 0, 0);
      context.restore();
    }

    function ccfDrawArrowHead(context, point, angle) {
      var size = 8;
      context.beginPath();
      context.moveTo(point.x, point.y);
      context.lineTo(point.x + Math.cos(angle + 0.55) * size, point.y + Math.sin(angle + 0.55) * size);
      context.lineTo(point.x + Math.cos(angle - 0.55) * size, point.y + Math.sin(angle - 0.55) * size);
      context.closePath();
      context.fill();
    }

    function ccfDrawDimension(context, start, end, label, labelOffset, dimensionColor) {
      var dx = end.x - start.x;
      var dy = end.y - start.y;
      var angle = Math.atan2(dy, dx);
      var ink = dimensionColor || "#0a587e";
      context.save();
      context.strokeStyle = ink;
      context.fillStyle = ink;
      context.lineWidth = 2;
      context.beginPath();
      context.moveTo(start.x, start.y);
      context.lineTo(end.x, end.y);
      context.stroke();
      ccfDrawArrowHead(context, start, angle);
      ccfDrawArrowHead(context, end, angle + Math.PI);
      context.font = "800 18px Figtree, Arial, sans-serif";
      context.textAlign = "center";
      context.textBaseline = "middle";
      var labelX = (start.x + end.x) / 2 + (labelOffset && labelOffset.x || 0);
      var labelY = (start.y + end.y) / 2 + (labelOffset && labelOffset.y || 0);
      var labelWidth = context.measureText(label).width + 18;
      context.beginPath();
      roundedRectPath(context, labelX - labelWidth / 2, labelY - 15, labelWidth, 30, 9);
      context.closePath();
      context.fillStyle = "rgba(255,255,255,0.94)";
      context.fill();
      context.strokeStyle = "rgba(10,88,126,0.22)";
      context.lineWidth = 1;
      context.stroke();
      context.fillStyle = ink;
      context.fillText(label, labelX, labelY + 1);
      context.restore();
    }

    function ccfThreeArtworkIsMirrored() {
      return threePreviewKind === "stamp" ? !threePreviewFlipped : threePreviewFlipped;
    }

    function ccfUpdateThreeModeCopy() {
      var impression = threePreviewKind === "impression";
      if (nodes.threeFrame) nodes.threeFrame.classList.toggle("is-impression", impression);
      if (nodes.threeBadge) nodes.threeBadge.textContent = impression ? "Cookie impression" : "Blue stamp face";
      if (nodes.threeMirror) nodes.threeMirror.textContent = threePreviewFlipped ? "Use default orientation" : "Mirror preview";
      if (nodes.threeHelp) {
        if (impression) {
          nodes.threeHelp.textContent = threePreviewFlipped
            ? "Reverse orientation shown for comparison. Switch back to see the intended readable orientation."
            : "Drag to rotate. Pinch or scroll to zoom. The recessed design shows the intended readable orientation.";
        } else {
          nodes.threeHelp.textContent = threePreviewFlipped
            ? "Reverse orientation shown for comparison. The physical stamp face remains correctly mirrored by default."
            : "Drag to rotate. Pinch or scroll to zoom. The stamp face is mirrored so the cookie impression reads correctly.";
        }
      }
      if (nodes.threeCanvas) {
        nodes.threeCanvas.setAttribute(
          "aria-label",
          impression
            ? "Interactive 3D cookie impression visual guide. The design is recessed in the intended readable orientation. Drag to rotate, pinch or scroll to zoom."
            : "Interactive 3D stamp-face preview. The raised design is physically mirrored. Drag to rotate, pinch or scroll to zoom."
        );
      }
    }

    function renderThreePreview() {
      threeFrameRequest = 0;
      if (previewMode !== "3d" || !threeContext || !nodes.threeCanvas) return;
      var size = currentSize();
      var widthMm = Number(size.widthMm);
      var heightMm = Number(size.heightMm);
      var outer = ccfShapeOutlinePoints(currentShape().id, widthMm, heightMm);
      var projection = ccfThreeProjection(widthMm, heightMm);
      var stampMode = threePreviewKind === "stamp";
      var mirroredArtwork = ccfThreeArtworkIsMirrored();
      threeContext.setTransform(1, 0, 0, 1, 0, 0);
      threeContext.clearRect(0, 0, nodes.threeCanvas.width, nodes.threeCanvas.height);
      ccfDrawThreeShadow(threeContext, outer, projection);

      if (stampMode) {
        var baseTop = 4.4;
        var baseShoulder = Math.max(0.8, baseTop - 0.7);
        var stampTop = ccfScaleThreePoints(outer, 0.987, 0.987);
        ccfDrawThreeSides(threeContext, outer, 0, baseShoulder, projection, false, CCF_STAMP_MATERIAL);
        ccfDrawThreeBridge(threeContext, outer, baseShoulder, stampTop, baseTop, projection, false, CCF_STAMP_MATERIAL);
        ccfDrawThreeTop(threeContext, stampTop, baseTop, projection, CCF_STAMP_MATERIAL);

        if (designHasArtwork()) {
          var reliefLayers = 5;
          var reliefSide = ccfBuildThreeArtwork("#136f96", mirroredArtwork);
          var reliefTop = ccfBuildThreeArtwork("#67bad6", mirroredArtwork);
          for (var reliefIndex = 1; reliefIndex <= reliefLayers; reliefIndex += 1) {
            var reliefZ = baseTop + reliefIndex / reliefLayers * 1.35;
            ccfDrawProjectedArtwork(threeContext, reliefIndex === reliefLayers ? reliefTop : reliefSide, reliefZ, projection, widthMm, heightMm);
          }
        }

      } else {
        var cookieTop = 6.1;
        var cookieShoulder = 5.2;
        var cookieTopPoints = ccfScaleThreePoints(outer, 0.986, 0.986);
        ccfDrawThreeSides(threeContext, outer, 0, cookieShoulder, projection, false, CCF_COOKIE_MATERIAL);
        ccfDrawThreeBridge(threeContext, outer, cookieShoulder, cookieTopPoints, cookieTop, projection, false, CCF_COOKIE_MATERIAL);
        ccfDrawThreeTop(threeContext, cookieTopPoints, cookieTop, projection, CCF_COOKIE_MATERIAL);
        ccfDrawCookieTexture(threeContext, cookieTopPoints, cookieTop, projection, widthMm, heightMm);
        if (designHasArtwork()) {
          var impressionHighlight = ccfBuildThreeArtwork("rgba(244,194,128,0.66)", mirroredArtwork);
          var impressionShadow = ccfBuildThreeArtwork("rgba(89,39,21,0.72)", mirroredArtwork);
          var impressionCore = ccfBuildThreeArtwork("rgba(132,68,35,0.82)", mirroredArtwork);
          ccfDrawProjectedArtwork(threeContext, impressionHighlight, cookieTop + 0.04, projection, widthMm, heightMm, -1.7, -1.4);
          ccfDrawProjectedArtwork(threeContext, impressionShadow, cookieTop + 0.05, projection, widthMm, heightMm, 2.2, 2.1);
          ccfDrawProjectedArtwork(threeContext, impressionCore, cookieTop + 0.06, projection, widthMm, heightMm, 0.5, 0.6);
        }
      }

      var dimensionInk = stampMode ? "#0a587e" : "#6e3b22";
      var widthStart = ccfThreeProject({ x: -widthMm / 2, y: heightMm / 2 + 8, z: 0 }, projection);
      var widthEnd = ccfThreeProject({ x: widthMm / 2, y: heightMm / 2 + 8, z: 0 }, projection);
      ccfDrawDimension(threeContext, widthStart, widthEnd, widthMm.toFixed(widthMm % 1 ? 1 : 0) + " mm", { x: 0, y: 18 }, dimensionInk);
      var heightStart = ccfThreeProject({ x: widthMm / 2 + 8, y: -heightMm / 2, z: 0 }, projection);
      var heightEnd = ccfThreeProject({ x: widthMm / 2 + 8, y: heightMm / 2, z: 0 }, projection);
      ccfDrawDimension(threeContext, heightStart, heightEnd, heightMm.toFixed(heightMm % 1 ? 1 : 0) + " mm", { x: 25, y: 0 }, dimensionInk);
      if (nodes.threeSpec) {
        nodes.threeSpec.textContent = widthMm.toFixed(widthMm % 1 ? 1 : 0) + " × " + heightMm.toFixed(heightMm % 1 ? 1 : 0) + " mm · " + (stampMode ? "Stamp face preview" : "Cookie impression preview");
      }
      ccfUpdateThreeModeCopy();
      var count = Number(nodes.threeCanvas.getAttribute("data-three-render-count") || 0) + 1;
      nodes.threeCanvas.setAttribute("data-three-rendered", "true");
      nodes.threeCanvas.setAttribute("data-three-render-count", String(count));
      nodes.threeCanvas.setAttribute("data-three-artwork-source", hasExactProof() ? "exact" : "instant");
    }

    function ccfSetThreeMode(nextKind) {
      threePreviewKind = nextKind === "impression" ? "impression" : "stamp";
      threePreviewFlipped = false;
      nodes.threeModes.forEach(function(modeButton) {
        modeButton.setAttribute("aria-pressed", modeButton.getAttribute("data-three-mode") === threePreviewKind ? "true" : "false");
      });
      if (nodes.threeMirror) nodes.threeMirror.setAttribute("aria-pressed", "false");
      ccfUpdateThreeModeCopy();
      scheduleThreePreview();
    }

    function scheduleThreePreview() {
      if (previewMode !== "3d" || threeFrameRequest) return;
      threeFrameRequest = window.requestAnimationFrame(renderThreePreview);
    }

    function ccfSetThreeView(viewName) {
      if (viewName === "top") {
        threeView.yaw = 0;
        threeView.pitch = 0;
      } else {
        threeView.yaw = -0.52;
        threeView.pitch = 0.72;
      }
      if (viewName === "reset") threeView.zoom = 1;
      nodes.threeViews.forEach(function(buttonNode) {
        var pressed = buttonNode.getAttribute("data-three-view") === (viewName === "reset" ? "angled" : viewName);
        buttonNode.setAttribute("aria-pressed", pressed ? "true" : "false");
      });
      scheduleThreePreview();
    }

    function ccfSetPreviewMode(nextMode, focusTab) {
      previewMode = nextMode === "3d" ? "3d" : "2d";
      nodes.previewTabs.forEach(function(tab) {
        var active = tab.getAttribute("data-preview-tab") === previewMode;
        tab.setAttribute("aria-selected", active ? "true" : "false");
        tab.tabIndex = active ? 0 : -1;
        if (active && focusTab) tab.focus({ preventScroll: true });
      });
      nodes.previewPanels.forEach(function(panel) {
        panel.hidden = panel.getAttribute("data-preview-panel") !== previewMode;
      });
      if (previewMode === "3d") scheduleThreePreview();
      else renderEditor();
    }

    function ccfThreePointerDistance() {
      var points = Array.from(threePointers.values());
      if (points.length < 2) return 0;
      var dx = points[0].x - points[1].x;
      var dy = points[0].y - points[1].y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function handleThreePointerDown(event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      event.preventDefault();
      nodes.threeCanvas.focus({ preventScroll: true });
      threePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (threePointers.size === 2) threeLastPinchDistance = ccfThreePointerDistance();
      try { nodes.threeCanvas.setPointerCapture(event.pointerId); } catch (_error) {}
    }

    function handleThreePointerMove(event) {
      var previous = threePointers.get(event.pointerId);
      if (!previous) return;
      event.preventDefault();
      threePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (threePointers.size > 1) {
        var distance = ccfThreePointerDistance();
        if (threeLastPinchDistance > 0) threeView.zoom = Math.max(0.72, Math.min(1.5, threeView.zoom * distance / threeLastPinchDistance));
        threeLastPinchDistance = distance;
      } else {
        threeView.yaw += (event.clientX - previous.x) * 0.009;
        threeView.pitch = Math.max(0, Math.min(1.2, threeView.pitch + (event.clientY - previous.y) * 0.007));
        nodes.threeViews.forEach(function(buttonNode) { buttonNode.setAttribute("aria-pressed", "false"); });
      }
      scheduleThreePreview();
    }

    function handleThreePointerEnd(event) {
      threePointers.delete(event.pointerId);
      if (threePointers.size < 2) threeLastPinchDistance = 0;
    }

    function handleThreeKeyDown(event) {
      var handled = true;
      if (event.key === "ArrowLeft") threeView.yaw -= 0.1;
      else if (event.key === "ArrowRight") threeView.yaw += 0.1;
      else if (event.key === "ArrowUp") threeView.pitch = Math.max(0, threeView.pitch - 0.08);
      else if (event.key === "ArrowDown") threeView.pitch = Math.min(1.2, threeView.pitch + 0.08);
      else if (event.key === "+" || event.key === "=") threeView.zoom = Math.min(1.5, threeView.zoom + 0.08);
      else if (event.key === "-" || event.key === "_") threeView.zoom = Math.max(0.72, threeView.zoom - 0.08);
      else if (event.key === "Home") ccfSetThreeView("reset");
      else handled = false;
      if (!handled) return;
      event.preventDefault();
      scheduleThreePreview();
    }

    function editorPoint(event) {
      var bounds = nodes.editorCanvas.getBoundingClientRect();
      return {
        x: (event.clientX - bounds.left) * nodes.editorCanvas.width / Math.max(1, bounds.width),
        y: (event.clientY - bounds.top) * nodes.editorCanvas.height / Math.max(1, bounds.height)
      };
    }

    function hitAt(point) {
      if (state.selected) {
        var selectedHit = editorHits.find(function(hit) {
          return hit.kind === state.selected.kind && hit.id === state.selected.id;
        });
        if (
          selectedHit &&
          point.x >= selectedHit.x && point.x <= selectedHit.x + selectedHit.width &&
          point.y >= selectedHit.y && point.y <= selectedHit.y + selectedHit.height
        ) return selectedHit;
      }
      for (var index = editorHits.length - 1; index >= 0; index -= 1) {
        var hit = editorHits[index];
        if (point.x >= hit.x && point.x <= hit.x + hit.width && point.y >= hit.y && point.y <= hit.y + hit.height) return hit;
      }
      return null;
    }

    function pointerDistance(points) {
      var dx = points[0].x - points[1].x;
      var dy = points[0].y - points[1].y;
      return Math.max(1, Math.sqrt(dx * dx + dy * dy));
    }

    function selectedSizeBounds() {
      var selected = selectedObject();
      if (!selected || !state.selected) return null;
      if (state.selected.kind === "text") {
        var font = fontForLayer(selected);
        return { key: "heightMm", min: Number(font.minHeightMm), max: 28 };
      }
      var spec = elementSpec(selected);
      return { key: "sizeMm", min: Number(spec && spec.minSizeMm || 8), max: 35 };
    }

    function clampSelectedSize(value) {
      var selected = selectedObject();
      var bounds = selectedSizeBounds();
      if (!selected || !bounds) return false;
      var nextValue = Math.max(bounds.min, Math.min(bounds.max, Number(value)));
      if (Number(selected[bounds.key]) === nextValue) return false;
      selected[bounds.key] = nextValue;
      return true;
    }

    function finishEditorGesture(changed) {
      if (!changed) return;
      if (state.selected && state.selected.kind === "text") renderLayerEditor();
      else renderSelectedElements();
      invalidate();
    }

    function handleEditorPointerDown(event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      event.preventDefault();
      if (event.pointerType === "mouse" && !isMobileLayout()) nodes.editorCanvas.focus({ preventScroll: true });
      var point = editorPoint(event);
      activePointers.set(event.pointerId, point);
      try { nodes.editorCanvas.setPointerCapture(event.pointerId); } catch (_error) {}
      if (activePointers.size === 1) {
        var hit = hitAt(point);
        if (hit) {
          selectEditorObject(hit.kind, hit.id);
          if (hit.kind === "element") renderSelectedElements();
        } else {
          state.selected = null;
          renderEditor();
        }
        var selected = selectedObject();
        dragState = selected && state.selected ? {
          pointerId: event.pointerId,
          kind: state.selected.kind,
          id: state.selected.id,
          startX: point.x,
          startY: point.y,
          originX: Number(selected.x),
          originY: Number(selected.y),
          changed: false
        } : null;
      } else if (activePointers.size === 2 && selectedObject()) {
        var active = Array.from(activePointers.values());
        var selectedBounds = selectedSizeBounds();
        var selectedItem = selectedObject();
        pinchState = {
          distance: pointerDistance(active),
          startSize: Number(selectedItem[selectedBounds.key]),
          changed: false
        };
        dragState = null;
      }
    }

    function handleEditorPointerMove(event) {
      if (!activePointers.has(event.pointerId)) return;
      event.preventDefault();
      var point = editorPoint(event);
      activePointers.set(event.pointerId, point);
      if (pinchState && activePointers.size >= 2) {
        var active = Array.from(activePointers.values()).slice(0, 2);
        var changed = clampSelectedSize(pinchState.startSize * pointerDistance(active) / pinchState.distance);
        pinchState.changed = pinchState.changed || changed;
        if (changed) renderEditor();
        return;
      }
      if (!dragState || dragState.pointerId !== event.pointerId || !state.selected || state.selected.id !== dragState.id) return;
      var selected = selectedObject();
      if (!selected) return;
      var nextX = Math.max(0.03, Math.min(0.97, dragState.originX + (point.x - dragState.startX) / nodes.editorCanvas.width));
      var nextY = Math.max(0.03, Math.min(0.97, dragState.originY + (point.y - dragState.startY) / nodes.editorCanvas.height));
      if (Math.abs(nextX - Number(selected.x)) > 0.0001 || Math.abs(nextY - Number(selected.y)) > 0.0001) {
        selected.x = nextX;
        selected.y = nextY;
        dragState.changed = true;
        renderEditor();
      }
    }

    function handleEditorPointerEnd(event) {
      if (!activePointers.has(event.pointerId)) return;
      event.preventDefault();
      activePointers.delete(event.pointerId);
      var changed = false;
      if (pinchState && activePointers.size < 2) {
        changed = pinchState.changed;
        pinchState = null;
      }
      if (dragState && dragState.pointerId === event.pointerId) {
        changed = changed || dragState.changed;
        dragState = null;
      }
      if (changed) finishEditorGesture(true);
    }

    function bringSelectedToFront() {
      if (!state.selected) return false;
      var collection = state.selected.kind === "text" ? state.textLayers : state.elements;
      var index = collection.findIndex(function(item) { return item.id === state.selected.id; });
      if (index < 0 || index === collection.length - 1) return false;
      collection.push(collection.splice(index, 1)[0]);
      return true;
    }

    function deleteSelected() {
      if (!state.selected) return false;
      if (state.selected.kind === "text") {
        if (state.textLayers.length === 1) {
          currentLayer().text = "";
          return true;
        }
        state.textLayers = state.textLayers.filter(function(layer) { return layer.id !== state.selected.id; });
        activeLayerId = state.textLayers[0].id;
        state.selected = { kind: "text", id: activeLayerId };
        return true;
      }
      state.elements = state.elements.filter(function(element) { return element.id !== state.selected.id; });
      state.selected = null;
      return true;
    }

    function handleEditorAction(event) {
      var action = event.currentTarget.getAttribute("data-editor-action");
      if (action === "guides") {
        state.guides = !state.guides;
        event.currentTarget.setAttribute("aria-pressed", state.guides ? "true" : "false");
        renderEditor();
        sessionSave();
        return;
      }
      var selected = selectedObject();
      if (!selected) return;
      var changed = false;
      if (action === "center-x") { selected.x = 0.5; changed = true; }
      if (action === "center-y") { selected.y = 0.5; changed = true; }
      if (action === "smaller" || action === "larger") {
        var bounds = selectedSizeBounds();
        var delta = state.selected.kind === "text" ? 0.5 : 1;
        changed = clampSelectedSize(Number(selected[bounds.key]) + (action === "larger" ? delta : -delta));
      }
      if (action === "front") changed = bringSelectedToFront();
      if (action === "delete") changed = deleteSelected();
      if (!changed) return;
      renderLayerEditor();
      renderSelectedElements();
      invalidate();
    }

    function handleEditorKeyDown(event) {
      var selected = selectedObject();
      if (!selected) return;
      var changed = false;
      var movement = event.shiftKey ? 0.01 : 0.02;
      if (event.key === "ArrowLeft") { selected.x = Math.max(0.03, Number(selected.x) - movement); changed = true; }
      if (event.key === "ArrowRight") { selected.x = Math.min(0.97, Number(selected.x) + movement); changed = true; }
      if (event.key === "ArrowUp") { selected.y = Math.max(0.03, Number(selected.y) - movement); changed = true; }
      if (event.key === "ArrowDown") { selected.y = Math.min(0.97, Number(selected.y) + movement); changed = true; }
      if (event.key === "+" || event.key === "=") {
        var largerBounds = selectedSizeBounds();
        changed = clampSelectedSize(Number(selected[largerBounds.key]) + (state.selected.kind === "text" ? 0.5 : 1));
      }
      if (event.key === "-" || event.key === "_") {
        var smallerBounds = selectedSizeBounds();
        changed = clampSelectedSize(Number(selected[smallerBounds.key]) - (state.selected.kind === "text" ? 0.5 : 1));
      }
      if (event.key === "Delete" || event.key === "Backspace") changed = deleteSelected();
      if (event.key === "Escape") {
        state.selected = null;
        renderEditor();
        sessionSave();
        event.preventDefault();
        return;
      }
      if (!changed) return;
      event.preventDefault();
      renderLayerEditor();
      renderSelectedElements();
      invalidate();
    }

    function setGlobalError(message) {
      nodes.globalError.textContent = message || "";
      nodes.globalError.hidden = !message;
    }

    function sessionSave() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ state: state, step: step }));
      } catch (_error) {}
    }

    function invalidate(options) {
      options = options || {};
      if (committedChecksum && !options.keepRevision) {
        state.revision += 1;
        committedChecksum = "";
      }
      lastPreview = null;
      if (nodes.approval) nodes.approval.checked = false;
      if (nodes.cartReviewDialog && nodes.cartReviewDialog.open) nodes.cartReviewDialog.close();
      if (nodes.openCartReview) {
        nodes.openCartReview.disabled = true;
        nodes.openCartReview.setAttribute("aria-disabled", "true");
      }
      if (nodes.addCart) {
        nodes.addCart.disabled = true;
        nodes.addCart.setAttribute("aria-disabled", "true");
      }
      if (previewController) previewController.abort();
      window.clearTimeout(previewTimer);
      clearExactProof();
      nodes.proofBadge.classList.remove("is-ready", "is-checking");
      nodes.proofMessage.classList.remove("is-error");
      if (!options.keepClash) hideDesignClash();
      if (designHasArtwork()) {
        nodes.proofBadge.textContent = "Updating";
        nodes.proofBadge.classList.add("is-checking");
        nodes.proofMessage.textContent = "";
        nodes.proofFrame.setAttribute("aria-busy", "true");
      } else {
        nodes.proofBadge.textContent = "Ready";
        nodes.proofMessage.textContent = "";
        nodes.proofFrame.setAttribute("aria-busy", "false");
      }
      setGlobalError("");
      showDesignPreview();
      renderEditor();
      scheduleThreePreview();
      sessionSave();
      if (!options.deferProof && designHasArtwork()) schedulePreview(options.previewDelayMs);
    }

    function exactVariant() {
      var size = currentSize();
      return ccfFindExactAvailableVariant(product, currentShape().label, size.shopifyOption || size.name, state.product);
    }

    function expectedPriceCents() {
      var base = Number(currentSize().expectedPriceCents);
      if (!Number.isFinite(base)) return null;
      return base + (state.product === "stamp_cutter" ? 295 : 0);
    }

    function loadConfiguredProduct(force) {
      if (force) {
        productPromise = null;
        product = null;
      }
      if (productPromise) return productPromise;
      var handle = String(settings.productHandle || "").trim();
      if (!handle) return Promise.reject(new Error("The Shopify product handle is not configured."));
      productPromise = ccfRequestJson("/products/" + encodeURIComponent(handle) + ".js", {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function(result) {
        product = result;
        updateVariant();
        return result;
      }).catch(function(error) {
        productPromise = null;
        nodes.variantStatus.textContent = "Could not verify this product";
        nodes.price.textContent = "-";
        throw error;
      });
      return productPromise;
    }

    function updateVariant() {
      variant = exactVariant();
      if (!product) {
        nodes.variantStatus.textContent = "Checking live availability...";
        nodes.price.textContent = ccfMoney(expectedPriceCents());
      } else if (!variant) {
        nodes.variantStatus.textContent = "This combination is currently unavailable";
        nodes.price.textContent = "-";
      } else {
        nodes.variantStatus.textContent = "Available - current price verified";
        nodes.price.textContent = ccfMoney(variant.price);
      }
      updateActions();
    }

    function renderShapes() {
      nodes.shapes.textContent = "";
      shapes.forEach(function(shape) {
        var node = button("", "ccf-choice ccf-choice--shape");
        var label = document.createElement("span");
        label.textContent = shape.label;
        node.appendChild(renderShapeIcon(shape.id));
        node.appendChild(label);
        node.setAttribute("aria-pressed", shape.id === state.shapeId ? "true" : "false");
        node.classList.toggle("is-selected", shape.id === state.shapeId);
        node.addEventListener("click", function() {
          if (state.shapeId === shape.id) return;
          state.shapeId = shape.id;
          state.sizeName = shape.sizes[0].name;
          state.selected = null;
          renderShapes();
          renderSizes();
          updateVariant();
          invalidate();
        });
        nodes.shapes.appendChild(node);
      });
    }

    function renderSizes() {
      nodes.sizes.textContent = "";
      currentShape().sizes.forEach(function(size) {
        var node = button(size.name, "ccf-choice");
        var detail = document.createElement("small");
        detail.textContent = size.dimensions;
        node.appendChild(detail);
        var selected = ccfNormalizeOption(size.name) === ccfNormalizeOption(state.sizeName);
        node.setAttribute("aria-pressed", selected ? "true" : "false");
        node.classList.toggle("is-selected", selected);
        node.addEventListener("click", function() {
          state.sizeName = size.name;
          renderSizes();
          updateVariant();
          invalidate();
        });
        nodes.sizes.appendChild(node);
      });
    }

    function renderProductTypes() {
      nodes.productTypes.textContent = "";
      productTypes.forEach(function(item) {
        var node = button(item.label, "ccf-product-type");
        node.setAttribute("aria-pressed", item.id === state.product ? "true" : "false");
        node.classList.toggle("is-selected", item.id === state.product);
        node.addEventListener("click", function() {
          state.product = item.id;
          renderProductTypes();
          updateVariant();
          invalidate();
        });
        nodes.productTypes.appendChild(node);
      });
    }

    function renderLayerTabs() {
      nodes.layerTabs.textContent = "";
      state.textLayers.forEach(function(layer, index) {
        var label = layer.text ? layer.text.slice(0, 13) : "Line " + (index + 1);
        var node = button(label, "ccf-layer-tab");
        node.setAttribute("role", "tab");
        node.setAttribute("aria-selected", layer.id === activeLayerId ? "true" : "false");
        node.setAttribute("aria-pressed", layer.id === activeLayerId ? "true" : "false");
        node.classList.toggle("is-selected", layer.id === activeLayerId);
        node.addEventListener("click", function() {
          activeLayerId = layer.id;
          state.selected = { kind: "text", id: layer.id };
          renderLayerEditor();
          showDesignPreview();
          renderEditor();
        });
        nodes.layerTabs.appendChild(node);
      });
    }

    function renderLayerEditor() {
      var layer = currentLayer();
      if (!layer) return;
      nodes.textInput.value = layer.text;
      nodes.proofTextInput.value = layer.text;
      nodes.removeLayer.disabled = state.textLayers.length <= 1;
      nodes.addLayer.disabled = state.textLayers.length >= Number(limits.maxTextLayers || 4);
      renderLayerTabs();
      renderFonts();
      var font = currentFont();
      nodes.height.min = Number(font.minHeightMm);
      nodes.height.max = 28;
      if (Number(layer.heightMm) < Number(font.minHeightMm)) layer.heightMm = Number(font.minHeightMm);
      nodes.height.value = layer.heightMm;
      nodes.heightOutput.value = Number(layer.heightMm).toFixed(1) + " mm";
      nodes.curve.value = layer.curve;
      nodes.curveOutput.value = Math.round(Number(layer.curve) * 100) + "%";
      if (nodes.rotation) {
        nodes.rotation.value = layer.rotation || 0;
        nodes.rotationOutput.value = Math.round(Number(layer.rotation || 0)) + " degrees";
      }
    }

    function renderFonts() {
      var layer = currentLayer();
      nodes.fonts.textContent = "";
      fonts.forEach(function(font) {
        var node = button("", "ccf-font-choice");
        if (font.previewData) {
          var preview = document.createElement("img");
          preview.src = font.previewData;
          preview.alt = "";
          preview.loading = "lazy";
          preview.decoding = "async";
          preview.setAttribute("data-font-preview", font.id);
          node.appendChild(preview);
        }
        var label = document.createElement("span");
        label.className = "ccf-font-choice__name";
        label.textContent = font.label;
        node.appendChild(label);
        var detail = document.createElement("small");
        detail.textContent = font.category + " - min " + Number(font.minHeightMm).toFixed(1) + " mm";
        node.appendChild(detail);
        node.setAttribute("aria-pressed", font.id === layer.fontId ? "true" : "false");
        node.classList.toggle("is-selected", font.id === layer.fontId);
        node.addEventListener("click", function() {
          layer.fontId = font.id;
          layer.heightMm = Math.max(Number(layer.heightMm), Number(font.minHeightMm));
          state.selected = { kind: "text", id: layer.id };
          renderLayerEditor();
          invalidate({ previewDelayMs: 0 });
        });
        nodes.fonts.appendChild(node);
      });
    }

    function nextElementPosition() {
      var index = state.elements.length;
      var positions = [
        [0.5, 0.72], [0.32, 0.70], [0.68, 0.70], [0.5, 0.28],
        [0.30, 0.34], [0.70, 0.34], [0.25, 0.52], [0.75, 0.52]
      ];
      return positions[index % positions.length];
    }

    function renderElementTypes() {
      nodes.elements.textContent = "";
      elementTypes.forEach(function(item) {
        var node = button("", "ccf-element-choice");
        var thumbnail = document.createElement("canvas");
        thumbnail.width = 72;
        thumbnail.height = 72;
        thumbnail.setAttribute("aria-hidden", "true");
        var label = document.createElement("span");
        label.textContent = item.label;
        node.appendChild(thumbnail);
        node.appendChild(label);
        renderElementThumbnail(thumbnail, item.id);
        node.setAttribute("aria-pressed", "false");
        node.addEventListener("click", function() {
          if (state.elements.length >= Number(limits.maxElements || 8)) {
            setGlobalError("A design can contain at most " + Number(limits.maxElements || 8) + " elements.");
            return;
          }
          var position = nextElementPosition();
          var added = {
            id: ccfMakeId("element"), type: item.id,
            sizeMm: Number(item.minSizeMm), x: position[0], y: position[1], rotation: 0,
            mode: "filled", strokeMm: 1.4
          };
          state.elements.push(added);
          state.selected = { kind: "element", id: added.id };
          renderSelectedElements();
          showDesignPreview();
          invalidate();
        });
        nodes.elements.appendChild(node);
      });
    }

    function renderSelectedElements() {
      nodes.selectedElements.textContent = "";
      state.elements.forEach(function(element) {
        var spec = elementSpec(element);
        if (!spec) return;
        var row = document.createElement("div");
        row.className = "ccf-selected-element";
        row.classList.toggle("is-selected", !!(state.selected && state.selected.kind === "element" && state.selected.id === element.id));
        var header = document.createElement("div");
        header.className = "ccf-selected-element__header";
        var label = document.createElement("strong");
        label.textContent = spec.label;
        var selectButton = button("Select", "ccf-button--quiet");
        selectButton.addEventListener("click", function() {
          selectEditorObject("element", element.id);
          renderSelectedElements();
        });
        header.appendChild(label);
        header.appendChild(selectButton);
        row.appendChild(header);

        var sliders = document.createElement("div");
        sliders.className = "ccf-selected-element__sliders";
        var sizeLabel = document.createElement("label");
        var sizeText = document.createElement("span");
        sizeText.textContent = "Size " + Number(element.sizeMm).toFixed(1) + " mm";
        var sizeInput = document.createElement("input");
        sizeInput.type = "range";
        sizeInput.min = Number(spec.minSizeMm);
        sizeInput.max = 35;
        sizeInput.step = 0.5;
        sizeInput.value = element.sizeMm;
        sizeInput.addEventListener("input", function() {
          element.sizeMm = Number(sizeInput.value);
          sizeText.textContent = "Size " + Number(element.sizeMm).toFixed(1) + " mm";
          state.selected = { kind: "element", id: element.id };
          invalidate();
        });
        sizeLabel.appendChild(sizeText);
        sizeLabel.appendChild(sizeInput);
        var rotationLabel = document.createElement("label");
        var rotationText = document.createElement("span");
        rotationText.textContent = "Rotation " + Math.round(Number(element.rotation || 0)) + "°";
        var rotationInput = document.createElement("input");
        rotationInput.type = "range";
        rotationInput.min = -180;
        rotationInput.max = 180;
        rotationInput.step = 1;
        rotationInput.value = element.rotation || 0;
        rotationInput.addEventListener("input", function() {
          element.rotation = Number(rotationInput.value);
          rotationText.textContent = "Rotation " + Math.round(Number(element.rotation)) + "°";
          state.selected = { kind: "element", id: element.id };
          invalidate();
        });
        rotationLabel.appendChild(rotationText);
        rotationLabel.appendChild(rotationInput);
        sliders.appendChild(sizeLabel);
        sliders.appendChild(rotationLabel);
        row.appendChild(sliders);

        if (spec.supportsOutline) {
          var styleControls = document.createElement("div");
          styleControls.className = "ccf-element-style";
          ["filled", "outline"].forEach(function(mode) {
            var styleButton = button(mode === "filled" ? "Filled" : "Outline", "ccf-button--quiet");
            styleButton.setAttribute("aria-pressed", (element.mode || "filled") === mode ? "true" : "false");
            styleButton.addEventListener("click", function() {
              element.mode = mode;
              state.selected = { kind: "element", id: element.id };
              renderSelectedElements();
              invalidate();
            });
            styleControls.appendChild(styleButton);
          });
          row.appendChild(styleControls);
        }

        var controls = document.createElement("div");
        controls.className = "ccf-selected-element__controls";
        [["left", -0.02, 0], ["up", 0, -0.02], ["down", 0, 0.02], ["right", 0.02, 0]].forEach(function(move) {
          var moveButton = button(move[0], "ccf-button--quiet");
          moveButton.setAttribute("aria-label", "Move " + spec.label + " " + move[0]);
          moveButton.addEventListener("click", function() {
            element.x = Math.max(0.04, Math.min(0.96, Number(element.x) + move[1]));
            element.y = Math.max(0.04, Math.min(0.96, Number(element.y) + move[2]));
            state.selected = { kind: "element", id: element.id };
            invalidate();
          });
          controls.appendChild(moveButton);
        });
        var center = button("Centre", "ccf-button--quiet");
        center.addEventListener("click", function() {
          element.x = 0.5;
          element.y = 0.5;
          state.selected = { kind: "element", id: element.id };
          invalidate();
        });
        controls.appendChild(center);
        var remove = button("Remove", "ccf-button--danger");
        remove.addEventListener("click", function() {
          state.elements = state.elements.filter(function(item) { return item.id !== element.id; });
          if (state.selected && state.selected.kind === "element" && state.selected.id === element.id) state.selected = null;
          renderSelectedElements();
          invalidate();
        });
        controls.appendChild(remove);
        row.appendChild(controls);
        nodes.selectedElements.appendChild(row);
      });
    }

    function applyTextValue(rawValue) {
      var clean = ccfSanitizeDesignText(rawValue);
      var layer = currentLayer();
      state.selected = { kind: "text", id: layer.id };
      var max = Number(limits.maxTextCharacters || 25);
      layer.text = clean.value.slice(0, max);
      nodes.textInput.value = layer.text;
      nodes.proofTextInput.value = layer.text;
      if (clean.removed.length) {
        nodes.textHelp.textContent = "Unsupported symbols and emojis were removed. Letters, numbers and common punctuation are accepted.";
      } else {
        nodes.textHelp.textContent = "Letters, numbers and common punctuation only.";
      }
      nodes.textInput.removeAttribute("aria-invalid");
      nodes.proofTextInput.removeAttribute("aria-invalid");
      renderLayerTabs();
      invalidate();
    }

    function proofError(error) {
      var message = error && error.issues && error.issues[0] && error.issues[0].message || error.message || "Your design could not be checked. Please try again.";
      nodes.proofBadge.textContent = "Please adjust";
      nodes.proofBadge.classList.remove("is-ready", "is-checking");
      nodes.proofMessage.textContent = message;
      nodes.proofMessage.classList.add("is-error");
      nodes.proofFrame.setAttribute("aria-busy", "false");
      if (error && error.issues && error.issues[0]) showDesignClash(error.issues[0]);
      else hideDesignClash();
      updateActions();
    }

    function hideDesignClash() {
      if (!nodes.designClash) return;
      nodes.designClash.hidden = true;
      if (nodes.designClashMessage) nodes.designClashMessage.textContent = "";
      if (nodes.designClashStatus) nodes.designClashStatus.textContent = "";
      if (nodes.designAutoFix) {
        nodes.designAutoFix.hidden = true;
        nodes.designAutoFix.disabled = false;
      }
    }

    function showDesignClash(issue) {
      if (!nodes.designClash) return;
      issue = issue && typeof issue === "object" ? issue : {};
      nodes.designClash.hidden = false;
      nodes.designClashMessage.textContent = issue.message || "Part of your design is touching or too close to the stamp border.";
      var fix = issue.autoFix && issue.autoFix.action === "translate" ? issue.autoFix : null;
      nodes.designAutoFix.hidden = !fix;
      nodes.designAutoFix.disabled = false;
      nodes.designClashStatus.textContent = fix
        ? "The automatic fix will make the smallest safe move and then check the design again."
        : "Move the highlighted item away from the border or make it smaller, then wait for the design check.";

      var affected = Array.isArray(issue.affectedItems) ? issue.affectedItems : [];
      var firstAffected = affected[0];
      if (firstAffected && (firstAffected.kind === "text" || firstAffected.kind === "element")) {
        selectEditorObject(firstAffected.kind, String(firstAffected.id || ""));
      }
    }

    function applyDesignClashFix() {
      var issue = lastPreview && Array.isArray(lastPreview.issues) && lastPreview.issues[0];
      var fix = issue && issue.autoFix;
      if (!fix || fix.action !== "translate") return;
      var dx = Number(fix.dx);
      var dy = Number(fix.dy);
      var itemIds = Array.isArray(fix.itemIds) ? fix.itemIds.map(String) : [];
      if (!Number.isFinite(dx) || !Number.isFinite(dy) || !itemIds.length) return;
      var selectedIds = new Set(itemIds);
      var moved = [];
      state.textLayers.concat(state.elements).forEach(function(item) {
        if (!selectedIds.has(String(item.id))) return;
        item.x = Math.max(0.03, Math.min(0.97, Number(item.x) + dx));
        item.y = Math.max(0.03, Math.min(0.97, Number(item.y) + dy));
        moved.push(item);
      });
      if (!moved.length) return;

      var firstAffected = Array.isArray(issue.affectedItems) && issue.affectedItems[0];
      if (firstAffected) {
        state.selected = { kind: firstAffected.kind, id: String(firstAffected.id || "") };
        if (firstAffected.kind === "text") activeLayerId = String(firstAffected.id || "");
      }
      nodes.designAutoFix.disabled = true;
      nodes.designClashStatus.textContent = "Spacing adjusted. Checking the updated design now...";
      renderLayerEditor();
      renderSelectedElements();
      invalidate({ keepClash: true, previewDelayMs: 0 });
    }

    function requestPreview() {
      window.clearTimeout(previewTimer);
      if (!designHasArtwork()) return Promise.resolve();
      if (previewController) previewController.abort();
      previewController = typeof AbortController === "function" ? new AbortController() : null;
      var sequence = ++previewSequence;
      nodes.proofBadge.textContent = "Updating";
      nodes.proofBadge.classList.remove("is-ready");
      nodes.proofBadge.classList.add("is-checking");
      nodes.proofMessage.textContent = "";
      nodes.proofMessage.classList.remove("is-error");
      nodes.proofFrame.setAttribute("aria-busy", "true");
      return ccfRequestJson(String(settings.proxyPath || "/apps/ccf-builder").replace(/\/$/, "") + "/preview", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ design: state }),
        signal: previewController ? previewController.signal : undefined
      }).then(function(result) {
        if (sequence !== previewSequence) return;
        var issues = Array.isArray(result.issues) ? result.issues : [];
        return buildExactCustomerProof(result.proofData).then(function(preparedProof) {
          if (sequence !== previewSequence) return;
          exactProofCanvas = preparedProof;
          exactProofChecksum = String(result.canonicalChecksum || "");
          exactProofRenderHash = String(result.renderHash || "");
          lastPreview = {
            canonicalChecksum: exactProofChecksum,
            renderHash: exactProofRenderHash,
            issues: issues
          };
          nodes.editorCanvas.setAttribute("data-exact-proof-ready", "true");
          nodes.editorCanvas.setAttribute("data-exact-proof-render-hash", exactProofRenderHash);
          nodes.editorCanvas.setAttribute("data-exact-proof-fonts", state.textLayers.map(function(layer) { return layer.fontId; }).join(","));
          showDesignPreview();
          renderEditor();
          scheduleThreePreview();
          nodes.proofFrame.setAttribute("aria-busy", "false");
          nodes.proofBadge.classList.remove("is-checking");
          if (issues.length) {
            nodes.proofBadge.textContent = "Please adjust";
            nodes.proofBadge.classList.remove("is-ready");
            nodes.proofMessage.textContent = issues[0].message;
            nodes.proofMessage.classList.add("is-error");
            showDesignClash(issues[0]);
          } else {
            nodes.proofBadge.textContent = "Ready";
            nodes.proofBadge.classList.add("is-ready");
            nodes.proofMessage.textContent = "";
            nodes.proofMessage.classList.remove("is-error");
            hideDesignClash();
          }
          updateReview();
          updateActions();
        });
      }).catch(function(error) {
        if (error && error.name === "AbortError") return;
        if (sequence !== previewSequence) return;
        lastPreview = null;
        proofError(error);
      });
    }

    function schedulePreview(delayMs) {
      window.clearTimeout(previewTimer);
      var delay = Number(delayMs);
      previewTimer = window.setTimeout(requestPreview, Number.isFinite(delay) ? Math.max(0, delay) : PREVIEW_DELAY_MS);
    }

    function previewReady() {
      return !!(hasExactProof() && lastPreview && lastPreview.canonicalChecksum && lastPreview.renderHash && !lastPreview.issues.length);
    }

    function designHasArtwork() {
      return state.textLayers.some(function(layer) { return !!String(layer.text || "").trim(); }) || state.elements.length > 0;
    }

    function updateActions() {
      nodes.back.hidden = step === 1;
      nodes.next.hidden = step === 3;
      if (step === 1) {
        nodes.next.textContent = "Start designing";
        nodes.next.disabled = !!(product && !variant);
      } else if (step === 2) {
        nodes.next.textContent = "Review your order";
        nodes.next.disabled = !variant || !previewReady() || !designHasArtwork();
      }
      if (nodes.openCartReview) {
        var reviewReady = step === 3 && variant && previewReady() && designHasArtwork();
        nodes.openCartReview.disabled = !reviewReady;
        nodes.openCartReview.setAttribute("aria-disabled", reviewReady ? "false" : "true");
      }
      if (nodes.addCart) {
        var cartReady = step === 3 && variant && previewReady() && designHasArtwork() && nodes.approval.checked;
        nodes.addCart.disabled = !cartReady;
        nodes.addCart.setAttribute("aria-disabled", cartReady ? "false" : "true");
      }
      if (nodes.openHelp) {
        var helpReady = designHasArtwork() && !helpSubmitting;
        nodes.openHelp.disabled = !helpReady;
        nodes.openHelp.setAttribute("aria-disabled", helpReady ? "false" : "true");
      }
    }

    function isMobileLayout() {
      return window.matchMedia("(max-width: 749.99px)").matches;
    }

    function moveProofDock() {
      var isMobile = isMobileLayout();
      var target = nodes.proofHome;
      if (isMobile && step === 2) target = nodes.mobileProofSlot;
      if (isMobile && step === 3) target = nodes.reviewProofSlot;
      if (target && nodes.proofDock.parentNode !== target) target.appendChild(nodes.proofDock);
    }

    function ccfKeepFocusedFieldWithPreview() {
      root.classList.toggle("ccf-builder--keyboard-open", !!(document.activeElement === nodes.textInput || document.activeElement === nodes.proofTextInput));
    }

    function renderReviewRows(target, rows) {
      if (!target) return;
      target.textContent = "";
      rows.forEach(function(row) {
        var wrapper = document.createElement("div");
        var term = document.createElement("dt");
        var detail = document.createElement("dd");
        term.textContent = row[0];
        detail.textContent = row[1];
        wrapper.appendChild(term);
        wrapper.appendChild(detail);
        target.appendChild(wrapper);
      });
    }

    function updateReview() {
      if (!nodes.review && !nodes.dialogReview) return;
      var text = state.textLayers.map(function(layer) { return layer.text; }).filter(Boolean).join(" / ") || "No text";
      var elementNames = state.elements.map(function(element) {
        var spec = elementTypes.find(function(item) { return item.id === element.type; });
        return spec ? spec.label : element.type;
      }).join(", ") || "None";
      var rows = [
        ["Shape", currentShape().label],
        ["Size", currentSize().name + " (" + currentSize().dimensions + ")"],
        ["Set", ccfProductTypeOption(state.product)],
        ["Text", text],
        ["Elements", elementNames]
      ];
      renderReviewRows(nodes.review, rows);
      renderReviewRows(nodes.dialogReview, rows);
      nodes.reviewPrice.textContent = variant ? ccfMoney(variant.price) : "-";
    }

    function renderCartReviewCanvas() {
      if (!nodes.cartReviewCanvas || !nodes.editorCanvas) return;
      var reviewContext = nodes.cartReviewCanvas.getContext("2d");
      if (!reviewContext) return;
      var selected = state.selected;
      var guides = state.guides;
      state.selected = null;
      state.guides = false;
      renderEditor();
      reviewContext.clearRect(0, 0, nodes.cartReviewCanvas.width, nodes.cartReviewCanvas.height);
      reviewContext.drawImage(nodes.editorCanvas, 0, 0, nodes.cartReviewCanvas.width, nodes.cartReviewCanvas.height);
      state.selected = selected;
      state.guides = guides;
      renderEditor();
    }

    function openCartReview() {
      if (!nodes.cartReviewDialog || !nodes.openCartReview || nodes.openCartReview.disabled) return;
      if (nodes.approval) nodes.approval.checked = false;
      updateReview();
      renderCartReviewCanvas();
      updateActions();
      if (typeof nodes.cartReviewDialog.showModal === "function") nodes.cartReviewDialog.showModal();
      else nodes.cartReviewDialog.setAttribute("open", "");
    }

    function closeCartReview() {
      if (!nodes.cartReviewDialog || !nodes.cartReviewDialog.open) return;
      if (typeof nodes.cartReviewDialog.close === "function") nodes.cartReviewDialog.close();
      else nodes.cartReviewDialog.removeAttribute("open");
    }

    function openDesignHelp() {
      if (!nodes.helpDialog || !nodes.openHelp || nodes.openHelp.disabled || !designHasArtwork()) return;
      helpRequestId = ccfMakeId("helpreq");
      helpSubmitting = false;
      if (nodes.helpWebsite) nodes.helpWebsite.value = "";
      if (nodes.helpConsent) nodes.helpConsent.checked = false;
      if (nodes.helpStatus) {
        nodes.helpStatus.textContent = "";
        nodes.helpStatus.classList.remove("is-error", "is-success");
      }
      if (nodes.submitHelp) {
        nodes.submitHelp.disabled = false;
        nodes.submitHelp.textContent = "Send design for help";
      }
      if (typeof nodes.helpDialog.showModal === "function") nodes.helpDialog.showModal();
      else nodes.helpDialog.setAttribute("open", "");
      window.setTimeout(function() {
        if (nodes.helpEmail) nodes.helpEmail.focus({ preventScroll: true });
      }, 0);
    }

    function closeDesignHelp(event) {
      if (!nodes.helpDialog || !nodes.helpDialog.open) return;
      var returnToEditor = Boolean(
        event &&
        event.currentTarget &&
        event.currentTarget.hasAttribute &&
        event.currentTarget.hasAttribute("data-return-to-editor") &&
        isMobileLayout() &&
        step === 2
      );
      if (returnToEditor) root.classList.add("ccf-builder--keyboard-open");
      if (typeof nodes.helpDialog.close === "function") nodes.helpDialog.close();
      else nodes.helpDialog.removeAttribute("open");
      if (returnToEditor && nodes.proofTextInput) {
        window.setTimeout(function() {
          nodes.proofTextInput.focus({ preventScroll: true });
          ccfKeepFocusedFieldWithPreview();
        }, 0);
      }
    }

    function submitDesignHelp(event) {
      event.preventDefault();
      if (helpSubmitting || !nodes.helpForm || !designHasArtwork()) return;
      if (typeof nodes.helpForm.reportValidity === "function" && !nodes.helpForm.reportValidity()) return;
      helpSubmitting = true;
      if (!helpRequestId) helpRequestId = ccfMakeId("helpreq");
      if (nodes.submitHelp) {
        nodes.submitHelp.disabled = true;
        nodes.submitHelp.textContent = "Sending securely...";
      }
      if (nodes.helpStatus) {
        nodes.helpStatus.textContent = "Sending an exact private copy of this design...";
        nodes.helpStatus.classList.remove("is-error", "is-success");
      }
      updateActions();
      ccfRequestJson(String(settings.proxyPath || "/apps/ccf-builder").replace(/\/$/, "") + "/help", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({
          design: state,
          requestId: helpRequestId,
          website: nodes.helpWebsite ? nodes.helpWebsite.value : "",
          customer: {
            name: nodes.helpName ? nodes.helpName.value : "",
            email: nodes.helpEmail ? nodes.helpEmail.value : "",
            note: nodes.helpNote ? nodes.helpNote.value : "",
            consent: Boolean(nodes.helpConsent && nodes.helpConsent.checked)
          }
        })
      }).then(function(result) {
        helpSubmitting = false;
        if (nodes.submitHelp) {
          nodes.submitHelp.disabled = true;
          nodes.submitHelp.textContent = "Design sent";
        }
        if (nodes.helpStatus) {
          nodes.helpStatus.textContent = "Thanks—your design has been sent to the Cookie Cutter Team. We’ll reply by email. Reference: " + String(result.helpRef || "");
          nodes.helpStatus.classList.add("is-success");
        }
        saveOnDevice();
        updateActions();
      }).catch(function(error) {
        helpSubmitting = false;
        if (nodes.submitHelp) {
          nodes.submitHelp.disabled = false;
          nodes.submitHelp.textContent = "Try again";
        }
        if (nodes.helpStatus) {
          nodes.helpStatus.textContent = error.message || "The design could not be sent. Please try again.";
          nodes.helpStatus.classList.add("is-error");
        }
        updateActions();
      });
    }

    function loadHelpResponse() {
      if (!window.URL || !window.URLSearchParams) return Promise.resolve(false);
      var pageUrl = new URL(window.location.href);
      var token = String(pageUrl.searchParams.get("ccf_help") || "").trim();
      if (!token) return Promise.resolve(false);
      return ccfRequestJson(
        String(settings.proxyPath || "/apps/ccf-builder").replace(/\/$/, "") +
          "/help-response?token=" + encodeURIComponent(token),
        {
          method: "GET",
          credentials: "same-origin",
          cache: "no-store",
          headers: { "Accept": "application/json" }
        }
      ).then(function(result) {
        var response = result && result.response;
        if (!response || !validateSavedState(response.design)) {
          throw new Error("The updated design could not be loaded.");
        }
        applySavedState(response.design, 2);
        if (nodes.helpResponse) nodes.helpResponse.hidden = false;
        if (nodes.helpResponseMessage) {
          nodes.helpResponseMessage.textContent = "We’ve loaded the version prepared by the Cookie Cutter Team. Please review it carefully and keep editing if needed.";
        }
        pageUrl.searchParams.delete("ccf_help");
        if (window.history && typeof window.history.replaceState === "function") {
          window.history.replaceState({}, "", pageUrl.toString());
        }
        sessionSave();
        return true;
      }).catch(function(error) {
        setGlobalError(error.message || "This design-help link is no longer available.");
        return false;
      });
    }

    function showStep(nextStep, focusHeading) {
      step = Math.max(1, Math.min(3, Number(nextStep) || 1));
      nodes.stages.forEach(function(stageNode) {
        stageNode.hidden = Number(stageNode.getAttribute("data-stage")) !== step;
      });
      nodes.progress.forEach(function(progressNode) {
        var number = Number(progressNode.getAttribute("data-progress"));
        progressNode.classList.toggle("is-active", number === step);
        progressNode.classList.toggle("is-complete", number < step);
        if (number === step) progressNode.setAttribute("aria-current", "step");
        else progressNode.removeAttribute("aria-current");
      });
      moveProofDock();
      if (step === 3) {
        ccfSetPreviewMode("2d", false);
        showDesignPreview();
      }
      updateReview();
      updateActions();
      sessionSave();
      if (focusHeading) {
        var heading = nodes.stages[step - 1].querySelector("h2");
        if (heading) {
          heading.setAttribute("tabindex", "-1");
          heading.focus({ preventScroll: true });
          var mobilePersonalise = step === 2 && isMobileLayout();
          (mobilePersonalise ? nodes.proofDock : heading).scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    }

    function validateSavedState(candidate) {
      if (!candidate || typeof candidate !== "object") return false;
      if (candidate.schemaVersion !== catalog.schemaVersion) return false;
      var candidateShape = shapes.find(function(shape) { return shape.id === candidate.shapeId; });
      if (!candidateShape || !candidateShape.sizes.some(function(size) { return ccfNormalizeOption(size.name) === ccfNormalizeOption(candidate.sizeName); })) return false;
      if (!productTypes.some(function(item) { return item.id === candidate.product; })) return false;
      if (!Array.isArray(candidate.textLayers) || !Array.isArray(candidate.elements)) return false;
      if (!candidate.textLayers.every(function(layer) { return fonts.some(function(font) { return font.id === layer.fontId; }); })) return false;
      return true;
    }

    function applySavedState(candidate, savedStep) {
      if (!validateSavedState(candidate)) return false;
      state = JSON.parse(JSON.stringify(candidate));
      state.catalogVersion = catalog.catalogVersion;
      state.rendererVersion = catalog.rendererVersion;
      state.revision = Math.max(1, Number(state.revision) || 1);
      state.guides = state.guides !== false;
      state.selected = null;
      state.elements.forEach(function(element) {
        if (!element.mode) element.mode = "filled";
        if (!element.strokeMm) element.strokeMm = 1.4;
      });
      activeLayerId = state.textLayers[0] && state.textLayers[0].id;
      if (!activeLayerId) {
        state.textLayers = [{ id: ccfMakeId("text"), text: "", fontId: firstFont.id, heightMm: firstFont.minHeightMm, x: 0.5, y: 0.5, curve: 0, rotation: 0 }];
        activeLayerId = state.textLayers[0].id;
      }
      renderAll();
      showStep(Math.max(1, Math.min(3, Number(savedStep) || 1)), false);
      invalidate({ keepRevision: true });
      return true;
    }

    function savedDesignName(candidate) {
      var text = candidate.textLayers.map(function(layer) { return String(layer.text || "").trim(); }).filter(Boolean).join(" / ");
      var shape = shapes.find(function(item) { return item.id === candidate.shapeId; });
      return (text || ((shape ? shape.label : "Custom") + " design")).slice(0, 42);
    }

    function writeSavedDesigns(entries) {
      try { localStorage.setItem(savedListKey, JSON.stringify(entries.slice(0, SAVE_LIMIT))); } catch (_error) {}
    }

    function readSavedDesigns() {
      var entries = [];
      try {
        var parsed = JSON.parse(localStorage.getItem(savedListKey) || "[]");
        if (Array.isArray(parsed)) entries = parsed;
        var legacy = JSON.parse(localStorage.getItem(storageKey) || "null");
        if (legacy && legacy.savedByUser === true && validateSavedState(legacy.state)) {
          entries.unshift({
            id: legacy.state.designId || ccfMakeId("saved"),
            name: savedDesignName(legacy.state),
            savedAt: Date.now(),
            expiresAt: Number(legacy.expiresAt) || Date.now() + SAVE_TTL_MS,
            state: legacy.state,
            step: legacy.step
          });
          localStorage.removeItem(storageKey);
        }
      } catch (_error) {
        entries = [];
      }
      var seen = {};
      entries = entries.filter(function(entry) {
        var id = entry && String(entry.id || entry.state && entry.state.designId || "");
        if (!id || seen[id] || Number(entry.expiresAt) <= Date.now() || !validateSavedState(entry.state)) return false;
        seen[id] = true;
        return true;
      }).slice(0, SAVE_LIMIT);
      writeSavedDesigns(entries);
      return entries;
    }

    function renderSavedDesigns() {
      var entries = readSavedDesigns();
      nodes.savedDesigns.textContent = "";
      nodes.resume.hidden = entries.length === 0;
      entries.forEach(function(entry) {
        var row = document.createElement("div");
        row.className = "ccf-saved-design";
        var detail = document.createElement("div");
        var name = document.createElement("div");
        name.className = "ccf-saved-design__name";
        name.textContent = entry.name || savedDesignName(entry.state);
        var meta = document.createElement("div");
        meta.className = "ccf-saved-design__meta";
        meta.textContent = "Saved " + new Date(Number(entry.savedAt) || Date.now()).toLocaleDateString();
        detail.appendChild(name);
        detail.appendChild(meta);
        var resume = button("Resume", "ccf-button--quiet");
        resume.addEventListener("click", function() {
          applySavedState(entry.state, entry.step);
          nodes.resume.hidden = true;
        });
        var remove = button("Delete", "ccf-button--danger");
        remove.addEventListener("click", function() {
          writeSavedDesigns(entries.filter(function(item) { return item.id !== entry.id; }));
          renderSavedDesigns();
        });
        row.appendChild(detail);
        row.appendChild(resume);
        row.appendChild(remove);
        nodes.savedDesigns.appendChild(row);
      });
    }

    function offerSavedDesign() {
      renderSavedDesigns();
    }

    function restoreTabDesign() {
      try {
        var parsed = JSON.parse(sessionStorage.getItem(storageKey) || "null");
        if (!parsed || !validateSavedState(parsed.state)) return false;
        return applySavedState(parsed.state, parsed.step);
      } catch (_error) {
        try { sessionStorage.removeItem(storageKey); } catch (_ignored) {}
        return false;
      }
    }

    function saveOnDevice() {
      var now = Date.now();
      var entries = readSavedDesigns().filter(function(entry) { return entry.id !== state.designId; });
      entries.unshift({
        id: state.designId,
        name: savedDesignName(state),
        savedAt: now,
        expiresAt: now + Number(settings.saveDays || 7) * 24 * 60 * 60 * 1000,
        state: JSON.parse(JSON.stringify(state)),
        step: step
      });
      try {
        localStorage.setItem(savedListKey, JSON.stringify(entries.slice(0, SAVE_LIMIT)));
        var oldText = nodes.save.textContent;
        nodes.save.textContent = "Saved for 7 days (" + Math.min(entries.length, SAVE_LIMIT) + "/" + SAVE_LIMIT + ")";
        window.setTimeout(function() { nodes.save.textContent = oldText; }, 2200);
        renderSavedDesigns();
      } catch (_error) {
        setGlobalError("This browser could not save the design on this device.");
      }
    }

    function cartProperties(commit) {
      var textSummary = state.textLayers.map(function(layer) { return layer.text; }).filter(Boolean).join(" | ");
      var elementSummary = state.elements.map(function(element) { return element.type; }).join(", ");
      return {
        "_ccf_design": "custom_builder_v4",
        "_ccf_schema": catalog.schemaVersion,
        "_ccf_design_ref": commit.designRef,
        "_ccf_design_signature": commit.signature,
        "_ccf_shop": commit.shopDomain || commit.shop || "",
        "_ccf_design_id": state.designId,
        "_ccf_revision": String(state.revision),
        "_ccf_design_checksum": commit.canonicalChecksum,
        "_ccf_render_hash": commit.renderHash,
        "_ccf_shape": currentShape().label,
        "_ccf_size": currentSize().name + " (" + currentSize().dimensions + ")",
        "_ccf_product": ccfProductTypeOption(state.product),
        "_ccf_text": textSummary.slice(0, 160),
        "_ccf_elements": elementSummary.slice(0, 120),
        "_ccf_customer_approval": "true",
        "_ccf_preview_variation_acknowledged": "true"
      };
    }

    function addToCart() {
      if (!nodes.addCart || nodes.addCart.disabled || !previewReady() || !nodes.approval || !nodes.approval.checked) return;
      var previewAtCommit = { checksum: lastPreview.canonicalChecksum, renderHash: lastPreview.renderHash };
      nodes.addCart.disabled = true;
      nodes.addCart.setAttribute("aria-disabled", "true");
      nodes.addCart.textContent = "Adding to cart...";
      nodes.cartStatus.textContent = "Please wait while your custom design is added.";
      setGlobalError("");
      ccfRequestJson(String(settings.proxyPath || "/apps/ccf-builder").replace(/\/$/, "") + "/commit", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ design: state })
      }).then(function(commit) {
        if (commit.canonicalChecksum !== previewAtCommit.checksum || commit.renderHash !== previewAtCommit.renderHash) {
          throw new Error("Your latest changes were not ready yet. Nothing was added to cart; please review your design again.");
        }
        committedChecksum = commit.canonicalChecksum;
        return loadConfiguredProduct(true).then(function() {
          variant = exactVariant();
          if (!variant) throw new Error("This exact Shopify variant is no longer available.");
          return ccfRequestJson("/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Accept": "application/json", "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: cartProperties(commit) }] })
          });
        });
      }).then(function() {
        nodes.addCart.textContent = "Added to cart";
        nodes.cartStatus.textContent = "Your custom design has been added to cart.";
        try { localStorage.removeItem(storageKey); sessionStorage.removeItem(storageKey); } catch (_error) {}
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        window.setTimeout(function() {
          window.location.assign("/cart");
        }, 350);
      }).catch(function(error) {
        nodes.addCart.textContent = "Confirm and add to cart";
        nodes.cartStatus.textContent = "";
        closeCartReview();
        setGlobalError(error.message || "The design could not be added to cart. Your design remains on this page.");
        updateActions();
      });
    }

    function renderAll() {
      renderShapes();
      renderSizes();
      renderProductTypes();
      renderLayerEditor();
      renderElementTypes();
      renderSelectedElements();
      updateVariant();
      updateReview();
      renderEditor();
      scheduleThreePreview();
    }

    var uiVersionCheckInFlight = false;
    function checkCurrentUiVersion() {
      var currentVersion = String(root.getAttribute("data-ccf-ui-version") || "");
      if (!currentVersion || uiVersionCheckInFlight || !window.fetch || !window.URL) return;
      uiVersionCheckInFlight = true;
      var checkUrl = new URL(window.location.href);
      checkUrl.searchParams.set("_ccf_ui_check", String(Date.now()));
      window.fetch(checkUrl.toString(), {
        method: "GET",
        cache: "no-store",
        credentials: "same-origin",
        headers: { "Accept": "text/html" }
      }).then(function(response) {
        if (!response.ok) throw new Error("Version check failed.");
        return response.text();
      }).then(function(html) {
        var match = String(html || "").match(/data-ccf-ui-version=["']([^"']+)["']/i);
        var availableVersion = match ? String(match[1]) : "";
        root.setAttribute("data-ccf-ui-version-checked", availableVersion || "unavailable");
        if (!availableVersion || availableVersion === currentVersion) return;
        sessionSave();
        var refreshUrl = new URL(window.location.href);
        refreshUrl.searchParams.delete("_ccf_ui_check");
        refreshUrl.searchParams.set("ccf_ui", availableVersion);
        window.location.replace(refreshUrl.toString());
      }).catch(function() {
        root.setAttribute("data-ccf-ui-version-checked", "unavailable");
      }).then(function() {
        uiVersionCheckInFlight = false;
      });
    }

    root.addEventListener("contextmenu", function(event) {
      if (event.target && event.target.closest && event.target.closest("input, textarea")) return;
      event.preventDefault();
    }, true);
    root.addEventListener("dragstart", function(event) {
      if (event.target && event.target.closest && event.target.closest("img, canvas, svg")) event.preventDefault();
    }, true);
    document.addEventListener("keydown", function(event) {
      if (!root.isConnected) return;
      var saveShortcut = (event.ctrlKey || event.metaKey) && String(event.key || "").toLowerCase() === "s";
      if (!saveShortcut) return;
      var interactingWithBuilder = root.contains(event.target) || root.contains(document.activeElement) || root.matches(":hover");
      if (interactingWithBuilder) event.preventDefault();
    }, true);

    nodes.textInput.addEventListener("compositionstart", function() { composing = true; });
    nodes.textInput.addEventListener("compositionend", function(event) { composing = false; applyTextValue(event.target.value); });
    nodes.textInput.addEventListener("input", function(event) { if (!composing) applyTextValue(event.target.value); });
    nodes.proofTextInput.addEventListener("compositionstart", function() { composing = true; });
    nodes.proofTextInput.addEventListener("compositionend", function(event) { composing = false; applyTextValue(event.target.value); });
    nodes.proofTextInput.addEventListener("input", function(event) { if (!composing) applyTextValue(event.target.value); });
    [nodes.textInput, nodes.proofTextInput].forEach(function(input) {
      input.addEventListener("focus", ccfKeepFocusedFieldWithPreview);
      input.addEventListener("blur", ccfKeepFocusedFieldWithPreview);
    });

    nodes.previewTabs.forEach(function(tab) {
      tab.addEventListener("click", function() {
        ccfSetPreviewMode(tab.getAttribute("data-preview-tab"), false);
      });
      tab.addEventListener("keydown", function(event) {
        var currentIndex = nodes.previewTabs.indexOf(tab);
        var targetIndex = currentIndex;
        if (event.key === "ArrowLeft" || event.key === "ArrowUp") targetIndex = (currentIndex - 1 + nodes.previewTabs.length) % nodes.previewTabs.length;
        else if (event.key === "ArrowRight" || event.key === "ArrowDown") targetIndex = (currentIndex + 1) % nodes.previewTabs.length;
        else if (event.key === "Home") targetIndex = 0;
        else if (event.key === "End") targetIndex = nodes.previewTabs.length - 1;
        else return;
        event.preventDefault();
        ccfSetPreviewMode(nodes.previewTabs[targetIndex].getAttribute("data-preview-tab"), true);
      });
    });

    nodes.threeViews.forEach(function(viewButton) {
      viewButton.addEventListener("click", function() { ccfSetThreeView(viewButton.getAttribute("data-three-view")); });
    });
    nodes.threeModes.forEach(function(modeButton) {
      modeButton.addEventListener("click", function() { ccfSetThreeMode(modeButton.getAttribute("data-three-mode")); });
    });
    if (nodes.threeMirror) nodes.threeMirror.addEventListener("click", function() {
      threePreviewFlipped = !threePreviewFlipped;
      nodes.threeMirror.setAttribute("aria-pressed", threePreviewFlipped ? "true" : "false");
      ccfUpdateThreeModeCopy();
      scheduleThreePreview();
    });
    if (nodes.threeCanvas) {
      nodes.threeCanvas.addEventListener("pointerdown", handleThreePointerDown);
      nodes.threeCanvas.addEventListener("pointermove", handleThreePointerMove);
      nodes.threeCanvas.addEventListener("pointerup", handleThreePointerEnd);
      nodes.threeCanvas.addEventListener("pointercancel", handleThreePointerEnd);
      nodes.threeCanvas.addEventListener("lostpointercapture", handleThreePointerEnd);
      nodes.threeCanvas.addEventListener("keydown", handleThreeKeyDown);
      nodes.threeCanvas.addEventListener("wheel", function(event) {
        event.preventDefault();
        threeView.zoom = Math.max(0.72, Math.min(1.5, threeView.zoom + (event.deltaY < 0 ? 0.08 : -0.08)));
        scheduleThreePreview();
      }, { passive: false });
    }

    nodes.addLayer.addEventListener("click", function() {
      if (state.textLayers.length >= Number(limits.maxTextLayers || 4)) return;
      var index = state.textLayers.length;
      var layer = { id: ccfMakeId("text"), text: "", fontId: firstFont.id, heightMm: Number(firstFont.minHeightMm), x: 0.5, y: Math.min(0.78, 0.42 + index * 0.15), curve: 0, rotation: 0 };
      state.textLayers.push(layer);
      activeLayerId = layer.id;
      state.selected = { kind: "text", id: layer.id };
      renderLayerEditor();
      invalidate();
      nodes.textInput.focus({ preventScroll: true });
    });

    nodes.removeLayer.addEventListener("click", function() {
      if (state.textLayers.length <= 1) return;
      state.textLayers = state.textLayers.filter(function(layer) { return layer.id !== activeLayerId; });
      activeLayerId = state.textLayers[0].id;
      state.selected = { kind: "text", id: activeLayerId };
      renderLayerEditor();
      invalidate();
    });

    nodes.height.addEventListener("input", function() {
      state.selected = { kind: "text", id: activeLayerId };
      currentLayer().heightMm = Number(nodes.height.value);
      nodes.heightOutput.value = Number(nodes.height.value).toFixed(1) + " mm";
      invalidate();
    });
    nodes.curve.addEventListener("input", function() {
      state.selected = { kind: "text", id: activeLayerId };
      currentLayer().curve = Number(nodes.curve.value);
      nodes.curveOutput.value = Math.round(Number(nodes.curve.value) * 100) + "%";
      invalidate();
    });
    if (nodes.rotation) nodes.rotation.addEventListener("input", function() {
      state.selected = { kind: "text", id: activeLayerId };
      currentLayer().rotation = Number(nodes.rotation.value);
      nodes.rotationOutput.value = Math.round(Number(nodes.rotation.value)) + " degrees";
      invalidate();
    });

    all("[data-nudge]").forEach(function(node) {
      node.addEventListener("click", function() {
        var layer = currentLayer();
        state.selected = { kind: "text", id: activeLayerId };
        var direction = node.getAttribute("data-nudge");
        if (direction === "up") layer.y -= 0.02;
        if (direction === "down") layer.y += 0.02;
        if (direction === "left") layer.x -= 0.02;
        if (direction === "right") layer.x += 0.02;
        if (direction === "center") { layer.x = 0.5; layer.y = 0.5; }
        layer.x = Math.max(0.03, Math.min(0.97, layer.x));
        layer.y = Math.max(0.03, Math.min(0.97, layer.y));
        invalidate();
      });
    });

    [
      ["[data-font-toggle]", "[data-font-body]"],
      ["[data-position-toggle]", "[data-position-body]"],
      ["[data-element-toggle]", "[data-element-body]"]
    ].forEach(function(pair) {
      var toggle = one(pair[0]);
      var panel = one(pair[1]);
      toggle.addEventListener("click", function() {
        ccfSetPanelExpanded(toggle, panel, toggle.getAttribute("aria-expanded") !== "true");
      });
    });

    nodes.next.addEventListener("click", function() {
      if (nodes.next.disabled) return;
      showStep(step + 1, true);
    });
    nodes.back.addEventListener("click", function() { showStep(step - 1, true); });
    nodes.save.addEventListener("click", saveOnDevice);
    if (nodes.editorCanvas) {
      nodes.editorCanvas.addEventListener("pointerdown", handleEditorPointerDown);
      nodes.editorCanvas.addEventListener("pointermove", handleEditorPointerMove);
      nodes.editorCanvas.addEventListener("pointerup", handleEditorPointerEnd);
      nodes.editorCanvas.addEventListener("pointercancel", handleEditorPointerEnd);
      nodes.editorCanvas.addEventListener("lostpointercapture", handleEditorPointerEnd);
      nodes.editorCanvas.addEventListener("keydown", handleEditorKeyDown);
    }
    if (nodes.editorToolbar) {
      Array.prototype.forEach.call(nodes.editorToolbar.querySelectorAll("[data-editor-action]"), function(node) {
        node.addEventListener("click", handleEditorAction);
      });
    }
    if (nodes.startNew) nodes.startNew.addEventListener("click", function() {
      state = freshDesignState();
      activeLayerId = state.textLayers[0].id;
      lastPreview = null;
      committedChecksum = "";
      showDesignPreview();
      renderAll();
      showStep(1, false);
      nodes.resume.hidden = true;
      invalidate({ keepRevision: true });
    });
    if (nodes.approval) nodes.approval.addEventListener("change", updateActions);
    if (nodes.openCartReview) nodes.openCartReview.addEventListener("click", openCartReview);
    if (nodes.openHelp) nodes.openHelp.addEventListener("click", openDesignHelp);
    if (nodes.helpForm) nodes.helpForm.addEventListener("submit", submitDesignHelp);
    nodes.closeHelp.forEach(function(node) { node.addEventListener("click", closeDesignHelp); });
    if (nodes.designAutoFix) nodes.designAutoFix.addEventListener("click", applyDesignClashFix);
    nodes.closeCartReview.forEach(function(node) { node.addEventListener("click", closeCartReview); });
    if (nodes.cartReviewDialog) {
      nodes.cartReviewDialog.addEventListener("close", function() {
        if (nodes.approval) nodes.approval.checked = false;
        updateActions();
      });
    }
    if (nodes.addCart) nodes.addCart.addEventListener("click", addToCart);

    var resizeTimer = 0;
    window.addEventListener("resize", function() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function() {
        moveProofDock();
        renderEditor();
        scheduleThreePreview();
      }, 80);
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", function() {
        root.style.setProperty("--ccf-visual-height", Math.round(window.visualViewport.height) + "px");
        ccfKeepFocusedFieldWithPreview();
      });
    }
    window.addEventListener("pageshow", function(event) {
      if (event.persisted) checkCurrentUiVersion();
    });

    loadHelpResponse().then(function(loadedHelpResponse) {
      var restoredFromTab = loadedHelpResponse ? true : restoreTabDesign();
      if (!restoredFromTab) {
        renderAll();
        showStep(1, false);
        offerSavedDesign();
      }
      loadConfiguredProduct(false).catch(function() {
        nodes.variantStatus.textContent = "Live availability is temporarily unavailable. You can keep designing.";
        nodes.price.textContent = ccfMoney(expectedPriceCents());
        updateActions();
      });
      if (!restoredFromTab && designHasArtwork()) requestPreview();
      checkCurrentUiVersion();
    });
  }

  function ccfBoot(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(parent.querySelectorAll("[data-ccf-builder-v4]"), ccfBuilder);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function() { ccfBoot(document); });
  else ccfBoot(document);
  document.addEventListener("shopify:section:load", function(event) { ccfBoot(event.target); });

  window.ccfFindExactAvailableVariant = ccfFindExactAvailableVariant;
  window.ccfSanitizeDesignText = ccfSanitizeDesignText;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ccf_made_for_you_proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mfy-proof]').forEach(function (root) {
      if (root.dataset.ready === '1') return;
      root.dataset.ready = '1';
      var token = new URLSearchParams(window.location.search).get('token') || '';
      var loading = root.querySelector('[data-proof-loading]');
      var content = root.querySelector('[data-proof-content]');
      var errorBox = root.querySelector('[data-proof-error]');
      var inlineError = root.querySelector('[data-proof-inline-error]');
      function money(cents) { return 'A$' + (Number(cents || 0) / 100).toFixed(2); }
      function escapeHtml(value) { var div=document.createElement('div'); div.textContent=String(value || ''); return div.innerHTML; }
      function fail(message) { loading.hidden=true; content.hidden=true; errorBox.hidden=false; root.querySelector('[data-proof-error-text]').textContent=message; }
      function inline(message) { inlineError.textContent=message; inlineError.hidden=!message; }
      function complete(title,text) { content.hidden=true; root.querySelector('[data-complete-title]').textContent=title; root.querySelector('[data-complete-text]').textContent=text; root.querySelector('[data-proof-complete]').hidden=false; root.querySelector('[data-proof-complete]').focus(); }
      function submit(decision,note,button) {
        inline(''); button.disabled=true;
        fetch(root.dataset.apiBase+'/'+encodeURIComponent(token)+'/decision',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({decision:decision,customer_note:note||''})})
          .then(function(response){return response.json().then(function(data){return {ok:response.ok,data:data};});})
          .then(function(result){
            if(!result.ok||!result.data||!result.data.ok) throw new Error((result.data&&result.data.error)||'submit_failed');
            if(decision==='approve') complete(root.dataset.completeApproveTitle,root.dataset.completeApproveText);
            else complete(root.dataset.completeChangesTitle,root.dataset.completeChangesText);
          })
          .catch(function(){button.disabled=false;inline(root.dataset.copySubmit);});
      }
      if (!/^mfyproof_[A-Za-z0-9_-]{30,}$/.test(token)) { fail(root.dataset.copyInvalid); return; }
      fetch(root.dataset.apiBase+'/'+encodeURIComponent(token)).then(function(response){return response.json().then(function(data){return {ok:response.ok,data:data};});}).then(function(result){
        if(!result.ok||!result.data||!result.data.ok) throw new Error('load_failed');
        var proof=result.data.proof||{};
        if(proof.status==='approved') { complete(root.dataset.completeApproveTitle,root.dataset.completeApproveText); return; }
        if(proof.status==='changes_requested') { complete(root.dataset.completeChangesTitle,root.dataset.completeChangesText); return; }
        root.querySelector('[data-proof-image]').src=proof.proof_url;
        root.querySelector('[data-proof-hello]').textContent=(root.dataset.helloPrefix||'')+(proof.customer_first_name||'');
        var rows=[[root.dataset.labelQuantity,String(proof.quantity||1)],[root.dataset.labelSize,String(proof.size_label||(String(proof.size_cm||'')+' cm'))],[root.dataset.labelTotal,money(proof.approved_total_cents)+' AUD']];
        root.querySelector('[data-proof-summary]').innerHTML=rows.map(function(row){return '<div><b>'+escapeHtml(row[0])+'</b><span>'+escapeHtml(row[1])+'</span></div>';}).join('');
        if(proof.proof_note){root.querySelector('[data-proof-note]').textContent=proof.proof_note;root.querySelector('[data-proof-note]').hidden=false;}
        loading.hidden=true;content.hidden=false;
      }).catch(function(){fail(root.dataset.copyLoad);});
      root.querySelector('[data-show-changes]').addEventListener('click',function(){root.querySelector('[data-proof-actions]').hidden=true;root.querySelector('[data-change-form]').hidden=false;root.querySelector('[data-change-note]').focus();});
      root.querySelector('[data-cancel-changes]').addEventListener('click',function(){root.querySelector('[data-change-form]').hidden=true;root.querySelector('[data-proof-actions]').hidden=false;inline('');});
      root.querySelector('[data-approve]').addEventListener('click',function(){submit('approve','',this);});
      root.querySelector('[data-send-changes]').addEventListener('click',function(){var note=root.querySelector('[data-change-note]').value.trim();if(note.length<3){inline(root.dataset.copyNote);return;}submit('request_changes',note,this);});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ccf_made_for_you_quote"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-ccf-mfy]');
    roots.forEach(function (root) {
      if (root.dataset.ready === '1') return;
      root.dataset.ready = '1';
      var form = root.querySelector('[data-mfy-form]');
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
      var currentStep = 1;
      var startedAt = Date.now();
      var uploadState = { url: '', key: '', name: '', size: 0, uploading: false };
      var base = { cutter_only:{'6.5':995,'8':1295,'10':1595}, stamp_only:{'6.5':1095,'8':1395,'10':1695}, stamp_and_cutter:{'6.5':1395,'8':1695,'10':1995} };
      var designFees = { business_logo:1400, name_or_text:1400, simple_drawing:1400, other:2000 };
      var stepNames = [root.dataset.stepItem,root.dataset.stepArtwork,root.dataset.stepContact,root.dataset.stepReview];

      function fieldValue(name) {
        var checked = form.querySelector('[name="' + name + '"]:checked');
        var input = checked || form.querySelector('[name="' + name + '"]');
        return input ? String(input.value || '').trim() : '';
      }
      function money(cents) { return 'A$' + (cents / 100).toFixed(2); }
      function earliestNeededBy() {
        var date = new Date();
        var added = 0;
        while (added < 3) {
          date.setDate(date.getDate() + 1);
          if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
        }
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return date.getFullYear() + '-' + month + '-' + day;
      }
      function setNeededByMinimum() {
        var input = form.querySelector('[name="needed_by"]');
        if (input) input.min = earliestNeededBy();
      }
      function selectedLabel(name) {
        var selected = form.querySelector('[name="' + name + '"]:checked');
        return selected ? String(selected.dataset.label || selected.value || '') : '';
      }
      function sizeLabel() {
        if (fieldValue('size_cm') !== 'custom') return selectedLabel('size_cm');
        var customSize = fieldValue('custom_size_cm');
        return customSize ? customSize + ' cm (custom)' : selectedLabel('size_cm');
      }
      function pricingSize() {
        var size = fieldValue('size_cm') || '6.5';
        if (size !== 'custom') return size;
        var customSize = parseFloat(fieldValue('custom_size_cm') || '10');
        if (customSize <= 6.5) return '6.5';
        if (customSize <= 8) return '8';
        return '10';
      }
      function updateCustomSize() {
        var wrap = root.querySelector('[data-custom-size]');
        var input = wrap.querySelector('input');
        var active = fieldValue('size_cm') === 'custom';
        wrap.hidden = !active;
        input.required = active;
        if (!active) input.classList.remove('is-invalid');
      }
      function estimate() {
        var product = fieldValue('product_type') || 'stamp_and_cutter';
        var design = fieldValue('design_type') || 'simple_drawing';
        var shape = fieldValue('shape') || 'circle';
        var size = fieldValue('size_cm') || '6.5';
        var priceSize = pricingSize();
        var quantity = Math.max(1, Math.min(100, parseInt(fieldValue('quantity') || '1', 10) || 1));
        var unit = base[product][priceSize];
        var items = unit * quantity;
        var designFee = designFees[design];
        var outlineFee = 0;
        var total = items + designFee + outlineFee;
        root.querySelector('[data-estimate-items]').textContent = money(items);
        root.querySelector('[data-estimate-design]').textContent = money(designFee);
        root.querySelector('[data-estimate-total]').textContent = money(total);
        return { pricing_version:'made_for_you_v2_2026_07', currency:'AUD', unit_cents:unit, quantity:quantity, items_cents:items, design_fee_cents:designFee, outline_fee_cents:outlineFee, estimated_total_cents:total, unit_display:money(unit), items_display:money(items), design_fee_display:money(designFee), outline_fee_display:money(outlineFee), estimated_total_display:money(total), shipping_included:false, proofs_included:1, small_revision_rounds_included:1, pricing_size_cm:priceSize, requires_manual_price_confirmation:size==='custom' };
      }
      function quoteData() {
        return {
          first_name:fieldValue('first_name'), last_name:fieldValue('last_name'), email:fieldValue('email').toLowerCase(), phone:fieldValue('phone'), postcode:fieldValue('postcode'),
          product_type:fieldValue('product_type'), design_type:fieldValue('design_type'), shape:fieldValue('shape'), size_cm:fieldValue('size_cm'), custom_size_cm:fieldValue('size_cm')==='custom' ? fieldValue('custom_size_cm') : '', quantity:parseInt(fieldValue('quantity') || '1',10) || 1,
          exact_wording:fieldValue('exact_wording'), design_notes:fieldValue('design_notes'), needed_by:fieldValue('needed_by'),
          reference_key:uploadState.key, reference_url:uploadState.url, reference_name:uploadState.name, reference_size:uploadState.size,
          artwork_permission:!!form.querySelector('[name="artwork_permission"]:checked'), fine_detail_ack:!!form.querySelector('[name="fine_detail_ack"]:checked'), quote_terms_ack:!!form.querySelector('[name="quote_terms_ack"]:checked')
        };
      }
      function showStatus(message) {
        var box = root.querySelector('[data-form-status]');
        box.textContent = message;
        box.hidden = !message;
        if (message) box.scrollIntoView({ behavior:'smooth', block:'center' });
      }
      function updateStep() {
        steps.forEach(function (step) { var active = Number(step.dataset.step) === currentStep; step.hidden = !active; step.classList.toggle('is-active', active); });
        root.querySelector('[data-step-number]').textContent = String(currentStep);
        root.querySelector('[data-step-name]').textContent = stepNames[currentStep - 1];
        root.querySelector('[data-progress-bar]').style.width = String(currentStep * 25) + '%';
        root.querySelector('[data-back]').hidden = currentStep === 1;
        root.querySelector('[data-next]').hidden = currentStep === 4;
        if (currentStep === 4) renderReview();
        showStatus('');
        form.scrollIntoView({ behavior:'smooth', block:'start' });
      }
      function validateStep(stepNumber) {
        var step = root.querySelector('[data-step="' + stepNumber + '"]');
        var fields = Array.prototype.slice.call(step.querySelectorAll('input,textarea,select'));
        var valid = true;
        fields.forEach(function (field) { field.classList.remove('is-invalid'); });
        fields.forEach(function (field) {
          if (field.disabled || field.closest('[hidden]')) return;
          if (!field.checkValidity()) { valid = false; field.classList.add('is-invalid'); }
        });
        if (stepNumber === 2 && (!uploadState.url || !uploadState.key)) valid = false;
        if (uploadState.uploading) { showStatus(root.dataset.errorUploading); return false; }
        if (!valid) {
          showStatus(stepNumber === 2 && !uploadState.url ? root.dataset.errorUpload : root.dataset.errorRequired);
          var first = step.querySelector('.is-invalid');
          if (first) first.focus();
        }
        return valid;
      }
      function renderReview() {
        var q = quoteData();
        var e = estimate();
        var rows = [
          [root.dataset.reviewItem,selectedLabel('product_type')], [root.dataset.reviewDesign,selectedLabel('design_type')], [root.dataset.reviewShape,selectedLabel('shape')], [root.dataset.reviewSize,sizeLabel()], [root.dataset.reviewQuantity,String(q.quantity)], [root.dataset.reviewReference,q.reference_name], [root.dataset.reviewEstimate,e.estimated_total_display + ' AUD']
        ];
        root.querySelector('[data-review-summary]').innerHTML = rows.map(function(row){ return '<div class="ccf-mfy__review-row"><b>'+row[0]+'</b><span>'+escapeHtml(row[1] || '-')+'</span></div>'; }).join('');
      }
      function escapeHtml(value) { var div=document.createElement('div'); div.textContent=String(value || ''); return div.innerHTML; }
      function humanSummary(q,e) {
        var lines = ['Made for you quote request','Customer: '+[q.first_name,q.last_name].filter(Boolean).join(' '),'Email: '+q.email,'Phone: '+(q.phone||'-'),'Postcode: '+(q.postcode||'-'),'','Item: '+selectedLabel('product_type'),'Design: '+selectedLabel('design_type'),'Shape: '+selectedLabel('shape'),'Size: '+sizeLabel()+' (longest point)','Quantity: '+q.quantity];
        if (q.exact_wording) lines.push('Exact wording: '+q.exact_wording);
        lines.push('Needed by: '+(q.needed_by||'No date supplied'),'Reference: '+(q.reference_name||'Uploaded image'),'Reference storage key: '+(q.reference_key||'-'),'','Design notes:',q.design_notes,'','Physical items: '+e.items_display,'Design service: '+e.design_fee_display);
        if (e.outline_fee_cents) lines.push('Custom outline: '+e.outline_fee_display);
        lines.push('Estimated total: '+e.estimated_total_display+' AUD','Shipping is calculated separately.','Includes one proof and one round of small changes.','Final price is confirmed after the artwork is checked.');
        return lines.join('\n');
      }
      function uploadFile(file) {
        if (!file) return;
        if (file.size > 8 * 1024 * 1024 || !/^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type)) { showStatus(root.dataset.errorUpload); return; }
        uploadState = { url:'', key:'', name:file.name, size:file.size, uploading:true };
        root.querySelector('[data-upload-status]').textContent = root.dataset.uploading;
        root.querySelector('[data-preview-image]').src = URL.createObjectURL(file);
        root.querySelector('[data-upload-preview]').hidden = false;
        var body = new FormData(); body.append('file', file, file.name);
        fetch(root.dataset.uploadUrl, { method:'POST', body:body }).then(function(response){ return response.json().catch(function(){ return {}; }); }).then(function(data){
          if (!data || !data.ok || !data.url || !data.key) throw new Error('upload_failed');
          uploadState.url=String(data.url); uploadState.key=String(data.key); uploadState.uploading=false;
          root.querySelector('[data-upload-status]').textContent = root.dataset.uploaded;
          showStatus('');
        }).catch(function(){ uploadState.uploading=false; root.querySelector('[data-upload-status]').textContent=''; showStatus(root.dataset.errorUpload); });
      }
      function submissionId() { return 'ccf_quote_' + Math.random().toString(36).slice(2,10); }
      function submitQuote(event) {
        event.preventDefault();
        if (!validateStep(4)) return;
        var q=quoteData(), e=estimate(), sid=submissionId();
        var machine={ version:1, pricing_version:e.pricing_version, quote:q, estimate:e, workflow_status:'submitted' };
        var message=humanSummary(q,e)+'\n\nCCF_QUOTE_JSON_BEGIN\n'+JSON.stringify(machine)+'\nCCF_QUOTE_JSON_END';
        var payload={ first_name:q.first_name,last_name:q.last_name,email:q.email,phone:q.phone,subject:'[Made for you] '+selectedLabel('product_type')+' - '+q.first_name,issue_type:'Made for you quote',issue_reason:selectedLabel('design_type'),selected_product:selectedLabel('product_type')+' | '+sizeLabel()+' | '+selectedLabel('shape'),requested_action:'Review artwork, confirm quote and prepare proof',message:message,submission_id:sid,submitted_at:new Date().toISOString(),photo_url:q.reference_url,photo_key:q.reference_key,photo_name:q.reference_name,photo_size:q.reference_size,page_url:window.location.href,source:'website_custom_quote',website:fieldValue('website'),form_started_at_ms:startedAt };
        var button=root.querySelector('[data-submit-button]'); button.disabled=true;
        fetch(root.dataset.submitUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)}).then(function(response){ return response.json().then(function(data){ return {ok:response.ok,data:data}; }); }).then(function(result){
          if (!result.ok || !result.data || !result.data.ok) throw new Error((result.data&&result.data.error)||'submit_failed');
          root.querySelector('[data-success-reference]').textContent=String(result.data.ticket_id||result.data.id||sid);
          root.querySelector('.ccf-mfy__layout').hidden=true; root.querySelector('[data-success]').hidden=false; root.querySelector('[data-success]').focus();
        }).catch(function(){ button.disabled=false; showStatus(root.dataset.errorSubmit); });
      }
      form.addEventListener('change',function(event){
        if (event.target.name==='design_type') { var exact=root.querySelector('[data-exact-wording]'); exact.hidden=event.target.value!=='name_or_text'; exact.querySelector('input').required=event.target.value==='name_or_text'; }
        if (event.target.name==='size_cm') updateCustomSize();
        estimate();
      });
      form.addEventListener('input',estimate);
      root.querySelector('[data-next]').addEventListener('click',function(){ if(validateStep(currentStep)){ currentStep+=1; updateStep(); } });
      root.querySelector('[data-back]').addEventListener('click',function(){ currentStep=Math.max(1,currentStep-1); updateStep(); });
      root.querySelector('[data-reference-file]').addEventListener('change',function(event){ uploadFile(event.target.files&&event.target.files[0]); });
      root.querySelector('[data-remove-image]').addEventListener('click',function(){ uploadState={url:'',key:'',name:'',size:0,uploading:false}; root.querySelector('[data-reference-file]').value=''; root.querySelector('[data-upload-preview]').hidden=true; root.querySelector('[data-upload-status]').textContent=''; });
      form.addEventListener('submit',submitQuote);
      setNeededByMinimum(); updateCustomSize(); estimate(); updateStep();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
